
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma-related types and utilities in a browser. 
 * Use it to get access to models, enums, and input types.
 * 
 * This file does not contain a `PrismaClient` class, nor several other helpers that are intended as server-side only.
 * See `client.ts` for the standard, server-side entry point.
 *
 * 🟢 You can import this file directly.
 */

import * as Prisma from './internal/prismaNamespaceBrowser'
export { Prisma }
export * as $Enums from './enums'
export * from './enums';
/**
 * Model User
 * 
 */
export type User = Prisma.UserModel
/**
 * Model Person
 * 
 */
export type Person = Prisma.PersonModel
/**
 * Model EmailAlias
 * 
 */
export type EmailAlias = Prisma.EmailAliasModel
/**
 * Model PersonTypeAssignment
 * 
 */
export type PersonTypeAssignment = Prisma.PersonTypeAssignmentModel
/**
 * Model RevenueDataManageGrant
 * 
 */
export type RevenueDataManageGrant = Prisma.RevenueDataManageGrantModel
/**
 * Model PersonTypeMapping
 * 
 */
export type PersonTypeMapping = Prisma.PersonTypeMappingModel
/**
 * Model ParticipantIdentity
 * 
 */
export type ParticipantIdentity = Prisma.ParticipantIdentityModel
/**
 * Model PersonExternalIdentity
 * 
 */
export type PersonExternalIdentity = Prisma.PersonExternalIdentityModel
/**
 * Model PersonRedirect
 * 
 */
export type PersonRedirect = Prisma.PersonRedirectModel
/**
 * Model PersonMatchCandidate
 * 
 */
export type PersonMatchCandidate = Prisma.PersonMatchCandidateModel
/**
 * Model CommitmentRecord
 * 
 */
export type CommitmentRecord = Prisma.CommitmentRecordModel
/**
 * Model CommitmentRecordView
 * 
 */
export type CommitmentRecordView = Prisma.CommitmentRecordViewModel
/**
 * Model CommitmentContest
 * 
 */
export type CommitmentContest = Prisma.CommitmentContestModel
/**
 * Model CommitmentRecordEnablement
 * 
 */
export type CommitmentRecordEnablement = Prisma.CommitmentRecordEnablementModel
/**
 * Model EnrollmentAssociation
 * 
 */
export type EnrollmentAssociation = Prisma.EnrollmentAssociationModel
/**
 * Model GuardianAssociation
 * 
 */
export type GuardianAssociation = Prisma.GuardianAssociationModel
/**
 * Model PersonDataAccess
 * 
 */
export type PersonDataAccess = Prisma.PersonDataAccessModel
/**
 * Model ProgramParticipationAssociation
 * 
 */
export type ProgramParticipationAssociation = Prisma.ProgramParticipationAssociationModel
/**
 * Model SectionEnrollmentAssociation
 * 
 */
export type SectionEnrollmentAssociation = Prisma.SectionEnrollmentAssociationModel
/**
 * Model MentorAssignment
 * 
 */
export type MentorAssignment = Prisma.MentorAssignmentModel
/**
 * Model Account
 * 
 */
export type Account = Prisma.AccountModel
/**
 * Model Session
 * 
 */
export type Session = Prisma.SessionModel
/**
 * Model VerificationToken
 * 
 */
export type VerificationToken = Prisma.VerificationTokenModel
/**
 * Model McpToken
 * 
 */
export type McpToken = Prisma.McpTokenModel
/**
 * Model OAuthAuthorizationCode
 * 
 */
export type OAuthAuthorizationCode = Prisma.OAuthAuthorizationCodeModel
/**
 * Model OAuthAccessToken
 * 
 */
export type OAuthAccessToken = Prisma.OAuthAccessTokenModel
/**
 * Model UpdateCadence
 * 
 */
export type UpdateCadence = Prisma.UpdateCadenceModel
/**
 * Model Rock
 * Rock - Unified work item hierarchy (Issue #1124)
 * 
 * Replaces the rigid Theme → BigRock → Bet hierarchy with a flexible
 * self-referential structure that allows unlimited nesting depth.
 * 
 * Key features:
 * - Self-referential parent/children relations for arbitrary hierarchy
 * - AIFE scoring fields (alignment, aifeImpact, effort, tier, leverageMultiplier) — the AIFE scoring spec (#7505) Steps 2–3
 * - Attribution/audit trail via RockScore table (leverageScore, rationale, overrideJustification)
 * - Hierarchy level determined by parent chain depth (Issue #1153)
 * 
 * Color: SchoolAI Blue (#2869DD light, #5A9AEF dark)
 * Icon: Gem
 */
export type Rock = Prisma.RockModel
/**
 * Model RockScore
 * 
 */
export type RockScore = Prisma.RockScoreModel
/**
 * Model Project
 * 
 */
export type Project = Prisma.ProjectModel
/**
 * Model RockProposalEdit
 * 
 */
export type RockProposalEdit = Prisma.RockProposalEditModel
/**
 * Model Update
 * 
 */
export type Update = Prisma.UpdateModel
/**
 * Model Changelog
 * 
 */
export type Changelog = Prisma.ChangelogModel
/**
 * Model ItemFollow
 * RETIRED (#16026): item follows have no reader or writer in `src/`. Kept
 * for the expand half of expand-contract; #15933 exports the rows and drops
 * the table. Do not add new reads or writes.
 */
export type ItemFollow = Prisma.ItemFollowModel
/**
 * Model Comment
 * 
 */
export type Comment = Prisma.CommentModel
/**
 * Model Organization
 * 
 */
export type Organization = Prisma.OrganizationModel
/**
 * Model OrgMembership
 * 
 */
export type OrgMembership = Prisma.OrgMembershipModel
/**
 * Model OrgPersonProfile
 * Per-org employment profile — ADR-0105 Decision 4, Issue #13885.
 * 
 * `Person` is a GLOBAL identity (`people.email` is globally unique and
 * `User.personId` is `@unique`, so one human is exactly one row
 * system-wide), yet it carried ten PER-ORG employment facts. For a human
 * attached to two orgs, `Person.managerId` has no defensible answer. One such
 * person exists in production.
 * 
 * KEYED `(personId, orgId)`, NOT `membershipId`. An earlier draft of the ADR
 * hung this off `OrgMembership`, which excludes exactly the population the
 * ADR's Context section establishes: Northgate's 609 students are attached by
 * ENROLLMENT and hold no membership, and child 6 drops `Person.isActive` — so
 * a student would have had nowhere left to carry it. The profile hangs off
 * ATTACHMENT (ADR-0105 Decision 1: `org_memberships`, `enrollment_associations`
 * or `guardian_associations`), which is the thing that actually generalizes.
 * 
 * A SEPARATE TABLE, NOT COLUMNS ON `OrgMembership`. `OrgMembership` is read on
 * every request to answer role and status; widening it to ten HR columns puts
 * employment data in the authorization hot path. NOT because of ADR-0060's
 * `no-permission-boolean-on-identity` rule — that rule's
 * `PERMISSION_NAME_PATTERN` matches `can[A-Z]…` / `may[A-Z]…` /
 * `is(Allowed|Permitted|Authorized)…` only, and its own comment names
 * `isActive` and `isContractor` as identity attributes that deliberately do
 * NOT match. ADR-0060 is silent here; the hot-path argument is the reason.
 * 
 * `managerId` keeps referencing `Person` — the manager is a human. What
 * becomes org-scoped is the REPORTING RELATIONSHIP, carried by this row's
 * `orgId`.
 * 
 * TRANSITIONAL: the ten columns on `Person` stay present and stay populated
 * (every writer dual-writes via `src/lib/org-person-profile.ts`) until child 6
 * (#13887) drops them. Reads resolve profile-first with a `Person` fallback.
 */
export type OrgPersonProfile = Prisma.OrgPersonProfileModel
/**
 * Model ExperiencePreset
 * 
 */
export type ExperiencePreset = Prisma.ExperiencePresetModel
/**
 * Model OrgFeatureFlag
 * 
 */
export type OrgFeatureFlag = Prisma.OrgFeatureFlagModel
/**
 * Model SlackIntegration
 * 
 */
export type SlackIntegration = Prisma.SlackIntegrationModel
/**
 * Model SlackChannelDigestConfig
 * 
 */
export type SlackChannelDigestConfig = Prisma.SlackChannelDigestConfigModel
/**
 * Model SlackCitizenshipViolation
 * 
 */
export type SlackCitizenshipViolation = Prisma.SlackCitizenshipViolationModel
/**
 * Model SlackChannelBackfillJob
 * 
 */
export type SlackChannelBackfillJob = Prisma.SlackChannelBackfillJobModel
/**
 * Model HubSpotConnection
 * 
 */
export type HubSpotConnection = Prisma.HubSpotConnectionModel
/**
 * Model GitHubAppInstallation
 * 
 */
export type GitHubAppInstallation = Prisma.GitHubAppInstallationModel
/**
 * Model NotionWorkspaceConnection
 * 
 */
export type NotionWorkspaceConnection = Prisma.NotionWorkspaceConnectionModel
/**
 * Model RipplingConnection
 * 
 */
export type RipplingConnection = Prisma.RipplingConnectionModel
/**
 * Model IntegrationConnection
 * 
 */
export type IntegrationConnection = Prisma.IntegrationConnectionModel
/**
 * Model IntegrationConnectionHealth
 * 
 */
export type IntegrationConnectionHealth = Prisma.IntegrationConnectionHealthModel
/**
 * Model PersonIntegrationConnection
 * 
 */
export type PersonIntegrationConnection = Prisma.PersonIntegrationConnectionModel
/**
 * Model HubSpotWebhookEvent
 * 
 */
export type HubSpotWebhookEvent = Prisma.HubSpotWebhookEventModel
/**
 * Model Reply
 * 
 */
export type Reply = Prisma.ReplyModel
/**
 * Model Reaction
 * 
 */
export type Reaction = Prisma.ReactionModel
/**
 * Model MetricsDashboard
 * 
 */
export type MetricsDashboard = Prisma.MetricsDashboardModel
/**
 * Model DashboardItem
 * 
 */
export type DashboardItem = Prisma.DashboardItemModel
/**
 * Model DashboardItemHistory
 * 
 */
export type DashboardItemHistory = Prisma.DashboardItemHistoryModel
/**
 * Model DashboardItemLink
 * 
 */
export type DashboardItemLink = Prisma.DashboardItemLinkModel
/**
 * Model REKSCriteria
 * 
 */
export type REKSCriteria = Prisma.REKSCriteriaModel
/**
 * Model WeeklyReflection
 * 
 */
export type WeeklyReflection = Prisma.WeeklyReflectionModel
/**
 * Model PulseCheckReview
 * 
 */
export type PulseCheckReview = Prisma.PulseCheckReviewModel
/**
 * Model PulseCheckShare
 * 
 */
export type PulseCheckShare = Prisma.PulseCheckShareModel
/**
 * Model PulseConversation
 * 
 */
export type PulseConversation = Prisma.PulseConversationModel
/**
 * Model PulseConversationMessage
 * 
 */
export type PulseConversationMessage = Prisma.PulseConversationMessageModel
/**
 * Model PulseConversationAnnotation
 * 
 */
export type PulseConversationAnnotation = Prisma.PulseConversationAnnotationModel
/**
 * Model PulsePersonalization
 * 
 */
export type PulsePersonalization = Prisma.PulsePersonalizationModel
/**
 * Model PulseWorkItemPassLog
 * 
 */
export type PulseWorkItemPassLog = Prisma.PulseWorkItemPassLogModel
/**
 * Model PulseUserTypeAffinity
 * 
 */
export type PulseUserTypeAffinity = Prisma.PulseUserTypeAffinityModel
/**
 * Model PulseConversationMemory
 * 
 */
export type PulseConversationMemory = Prisma.PulseConversationMemoryModel
/**
 * Model AiBeliefCorrection
 * 
 */
export type AiBeliefCorrection = Prisma.AiBeliefCorrectionModel
/**
 * Model SystemPrompt
 * 
 */
export type SystemPrompt = Prisma.SystemPromptModel
/**
 * Model ConfigVersion
 * 
 */
export type ConfigVersion = Prisma.ConfigVersionModel
/**
 * Model AiModelOverride
 * 
 */
export type AiModelOverride = Prisma.AiModelOverrideModel
/**
 * Model EmailTemplate
 * 
 */
export type EmailTemplate = Prisma.EmailTemplateModel
/**
 * Model PulseTeamSynthesis
 * 
 */
export type PulseTeamSynthesis = Prisma.PulseTeamSynthesisModel
/**
 * Model PersonPulseSynthesis
 * 
 */
export type PersonPulseSynthesis = Prisma.PersonPulseSynthesisModel
/**
 * Model PulseInsightsSummary
 * 
 */
export type PulseInsightsSummary = Prisma.PulseInsightsSummaryModel
/**
 * Model AffectSignal
 * 
 */
export type AffectSignal = Prisma.AffectSignalModel
/**
 * Model PerformanceReview
 * 
 */
export type PerformanceReview = Prisma.PerformanceReviewModel
/**
 * Model ReviewDateArchive
 * 
 */
export type ReviewDateArchive = Prisma.ReviewDateArchiveModel
/**
 * Model PerformanceReviewValueRating
 * 
 */
export type PerformanceReviewValueRating = Prisma.PerformanceReviewValueRatingModel
/**
 * Model PerformanceReviewValueException
 * 
 */
export type PerformanceReviewValueException = Prisma.PerformanceReviewValueExceptionModel
/**
 * Model DashboardItemReview
 * 
 */
export type DashboardItemReview = Prisma.DashboardItemReviewModel
/**
 * Model DashboardReviewDraft
 * 
 */
export type DashboardReviewDraft = Prisma.DashboardReviewDraftModel
/**
 * Model DashboardReviewSession
 * 
 */
export type DashboardReviewSession = Prisma.DashboardReviewSessionModel
/**
 * Model Feedback
 * 
 */
export type Feedback = Prisma.FeedbackModel
/**
 * Model FeedbackComment
 * 
 */
export type FeedbackComment = Prisma.FeedbackCommentModel
/**
 * Model FeedbackActivity
 * 
 */
export type FeedbackActivity = Prisma.FeedbackActivityModel
/**
 * Model FeedbackView
 * 
 */
export type FeedbackView = Prisma.FeedbackViewModel
/**
 * Model FeedbackAnchor
 * FeedbackAnchor — where on the page one piece of feedback points
 * (Issue #13574, part of #13573).
 * 
 * One optional row per `Feedback`. Feedback has carried `pageUrl` and a
 * screenshot since #1997, which say WHICH PAGE; none of it says WHICH
 * ELEMENT, so a triager reading "this button is wrong" on a page with nine
 * buttons is guessing. This table is that missing half.
 * 
 * `orgId` has NO DEFAULT. On a net-new tenant-scoped table an
 * `@default("org-schoolai")` converts a missing-`orgId` insert from a loud
 * failure into a silent write to the live org (#11901).
 */
export type FeedbackAnchor = Prisma.FeedbackAnchorModel
/**
 * Model FeedbackSession
 * FeedbackSession — one consented recording of one viewer's browsing
 * (Issue #13580, part of #13573).
 * 
 * The DATABASE half of session recording. The events themselves are never
 * stored here: they are JSON chunks in object storage under
 * `feedback-sessions/<orgId>/<id>/<index>.json`, expired by a bucket
 * lifecycle rule after
 * `FEEDBACK_SESSION_RETENTION_DAYS` (src/lib/feedback/session-recording.ts).
 * What this row holds is the part that must outlive them: who consented,
 * when, and how many chunks there were — so a triager reading a 40-day-old
 * thread is told the events EXPIRED rather than shown nothing and left to
 * infer that no session existed.
 * 
 * A row exists ONLY because a viewer opted in. There is no "session row
 * pending consent" state: `consentAt` is NOT NULL and is set at creation,
 * because a nullable one would make "recorded without consent" a
 * representable state, and the whole feature rests on it not being one.
 * 
 * `orgId` has NO DEFAULT (#11901). On a net-new tenant-scoped table a
 * `@default("org-schoolai")` converts a missing-`orgId` insert from a loud
 * failure into a silent write against the live org — here that would mean
 * one tenant's recorded DOM filed under another's.
 */
export type FeedbackSession = Prisma.FeedbackSessionModel
/**
 * Model REKSMeasurableLink
 * 
 */
export type REKSMeasurableLink = Prisma.REKSMeasurableLinkModel
/**
 * Model AiAuditResponse
 * 
 */
export type AiAuditResponse = Prisma.AiAuditResponseModel
/**
 * Model PatternView
 * 
 */
export type PatternView = Prisma.PatternViewModel
/**
 * Model PatternCache
 * 
 */
export type PatternCache = Prisma.PatternCacheModel
/**
 * Model KnowledgeGraphCache
 * 
 */
export type KnowledgeGraphCache = Prisma.KnowledgeGraphCacheModel
/**
 * Model PerformanceReviewSettings
 * 
 */
export type PerformanceReviewSettings = Prisma.PerformanceReviewSettingsModel
/**
 * Model PerformanceReviewPeriod
 * 
 */
export type PerformanceReviewPeriod = Prisma.PerformanceReviewPeriodModel
/**
 * Model TeamLeadAssignment
 * 
 */
export type TeamLeadAssignment = Prisma.TeamLeadAssignmentModel
/**
 * Model SelfEvaluationWindow
 * 
 */
export type SelfEvaluationWindow = Prisma.SelfEvaluationWindowModel
/**
 * Model SelfReflectionDraft
 * 
 */
export type SelfReflectionDraft = Prisma.SelfReflectionDraftModel
/**
 * Model FormDraft
 * 
 */
export type FormDraft = Prisma.FormDraftModel
/**
 * Model QuarterlyPerformanceReview
 * 
 */
export type QuarterlyPerformanceReview = Prisma.QuarterlyPerformanceReviewModel
/**
 * Model QuarterlyReviewRecommendation
 * 
 */
export type QuarterlyReviewRecommendation = Prisma.QuarterlyReviewRecommendationModel
/**
 * Model QuarterlyReviewCheckIn
 * 
 */
export type QuarterlyReviewCheckIn = Prisma.QuarterlyReviewCheckInModel
/**
 * Model QuarterlyReviewEditHistory
 * 
 */
export type QuarterlyReviewEditHistory = Prisma.QuarterlyReviewEditHistoryModel
/**
 * Model QuarterlyReviewPeriod
 * 
 */
export type QuarterlyReviewPeriod = Prisma.QuarterlyReviewPeriodModel
/**
 * Model EvaluationCadence
 * 
 */
export type EvaluationCadence = Prisma.EvaluationCadenceModel
/**
 * Model ContractorCheckIn
 * 
 */
export type ContractorCheckIn = Prisma.ContractorCheckInModel
/**
 * Model PeerReviewNomination
 * 
 */
export type PeerReviewNomination = Prisma.PeerReviewNominationModel
/**
 * Model ReviewSynthesis
 * 
 */
export type ReviewSynthesis = Prisma.ReviewSynthesisModel
/**
 * Model Plan
 * 
 */
export type Plan = Prisma.PlanModel
/**
 * Model PlanItem
 * 
 */
export type PlanItem = Prisma.PlanItemModel
/**
 * Model PlanLabel
 * 
 */
export type PlanLabel = Prisma.PlanLabelModel
/**
 * Model PlanItemAcceptance
 * 
 */
export type PlanItemAcceptance = Prisma.PlanItemAcceptanceModel
/**
 * Model PlanItemVersion
 * 
 */
export type PlanItemVersion = Prisma.PlanItemVersionModel
/**
 * Model PlanItemProposalEdit
 * 
 */
export type PlanItemProposalEdit = Prisma.PlanItemProposalEditModel
/**
 * Model IdeaHistory
 * 
 */
export type IdeaHistory = Prisma.IdeaHistoryModel
/**
 * Model EditSession
 * 
 */
export type EditSession = Prisma.EditSessionModel
/**
 * Model Notification
 * 
 */
export type Notification = Prisma.NotificationModel
/**
 * Model NotificationDelivery
 * 
 */
export type NotificationDelivery = Prisma.NotificationDeliveryModel
/**
 * Model NotificationPreference
 * 
 */
export type NotificationPreference = Prisma.NotificationPreferenceModel
/**
 * Model NotificationDeliveryLog
 * 
 */
export type NotificationDeliveryLog = Prisma.NotificationDeliveryLogModel
/**
 * Model PerformanceAlert
 * 
 */
export type PerformanceAlert = Prisma.PerformanceAlertModel
/**
 * Model ImpersonationLog
 * 
 */
export type ImpersonationLog = Prisma.ImpersonationLogModel
/**
 * Model Attachment
 * 
 */
export type Attachment = Prisma.AttachmentModel
/**
 * Model LinkAttachment
 * 
 */
export type LinkAttachment = Prisma.LinkAttachmentModel
/**
 * Model TrainingItem
 * 
 */
export type TrainingItem = Prisma.TrainingItemModel
/**
 * Model TrainingPlan
 * 
 */
export type TrainingPlan = Prisma.TrainingPlanModel
/**
 * Model TrainingPlanSection
 * 
 */
export type TrainingPlanSection = Prisma.TrainingPlanSectionModel
/**
 * Model TrainingPlanItem
 * 
 */
export type TrainingPlanItem = Prisma.TrainingPlanItemModel
/**
 * Model TrainingAssignment
 * 
 */
export type TrainingAssignment = Prisma.TrainingAssignmentModel
/**
 * Model TrainingItemProgress
 * 
 */
export type TrainingItemProgress = Prisma.TrainingItemProgressModel
/**
 * Model Announcement
 * 
 */
export type Announcement = Prisma.AnnouncementModel
/**
 * Model AnnouncementRecipient
 * 
 */
export type AnnouncementRecipient = Prisma.AnnouncementRecipientModel
/**
 * Model ProfileQuestionnaire
 * 
 */
export type ProfileQuestionnaire = Prisma.ProfileQuestionnaireModel
/**
 * Model PersonSensitiveData
 * 
 */
export type PersonSensitiveData = Prisma.PersonSensitiveDataModel
/**
 * Model RockDependency
 * 
 */
export type RockDependency = Prisma.RockDependencyModel
/**
 * Model PlanItemDependency
 * 
 */
export type PlanItemDependency = Prisma.PlanItemDependencyModel
/**
 * Model ProjectDependency
 * 
 */
export type ProjectDependency = Prisma.ProjectDependencyModel
/**
 * Model PersonWidgetPreference
 * 
 */
export type PersonWidgetPreference = Prisma.PersonWidgetPreferenceModel
/**
 * Model CoachingTopic
 * 
 */
export type CoachingTopic = Prisma.CoachingTopicModel
/**
 * Model CoachingPrepNote
 * 
 */
export type CoachingPrepNote = Prisma.CoachingPrepNoteModel
/**
 * Model FeatureFlag
 * 
 */
export type FeatureFlag = Prisma.FeatureFlagModel
/**
 * Model FeatureFlagUserOverride
 * 
 */
export type FeatureFlagUserOverride = Prisma.FeatureFlagUserOverrideModel
/**
 * Model FeatureFlagRoleOverride
 * 
 */
export type FeatureFlagRoleOverride = Prisma.FeatureFlagRoleOverrideModel
/**
 * Model AiChatConversation
 * 
 */
export type AiChatConversation = Prisma.AiChatConversationModel
/**
 * Model AiChatMessage
 * 
 */
export type AiChatMessage = Prisma.AiChatMessageModel
/**
 * Model AiChatMessageFeedback
 * 
 */
export type AiChatMessageFeedback = Prisma.AiChatMessageFeedbackModel
/**
 * Model UnmetNeed
 * 
 */
export type UnmetNeed = Prisma.UnmetNeedModel
/**
 * Model UnmetNeedMonitor
 * 
 */
export type UnmetNeedMonitor = Prisma.UnmetNeedMonitorModel
/**
 * Model AiChatResolvedEntity
 * 
 */
export type AiChatResolvedEntity = Prisma.AiChatResolvedEntityModel
/**
 * Model FeatureRecommendation
 * 
 */
export type FeatureRecommendation = Prisma.FeatureRecommendationModel
/**
 * Model MentionExchange
 * 
 */
export type MentionExchange = Prisma.MentionExchangeModel
/**
 * Model Survey
 * 
 */
export type Survey = Prisma.SurveyModel
/**
 * Model SurveyShare
 * 
 */
export type SurveyShare = Prisma.SurveyShareModel
/**
 * Model SurveyQuestion
 * 
 */
export type SurveyQuestion = Prisma.SurveyQuestionModel
/**
 * Model SurveyRecipient
 * 
 */
export type SurveyRecipient = Prisma.SurveyRecipientModel
/**
 * Model SurveyResponse
 * 
 */
export type SurveyResponse = Prisma.SurveyResponseModel
/**
 * Model SurveyAnswer
 * 
 */
export type SurveyAnswer = Prisma.SurveyAnswerModel
/**
 * Model SurveyInsightDismissal
 * 
 */
export type SurveyInsightDismissal = Prisma.SurveyInsightDismissalModel
/**
 * Model SurveyResponseComment
 * 
 */
export type SurveyResponseComment = Prisma.SurveyResponseCommentModel
/**
 * Model SurveyTemplate
 * 
 */
export type SurveyTemplate = Prisma.SurveyTemplateModel
/**
 * Model QuestionBankItem
 * 
 */
export type QuestionBankItem = Prisma.QuestionBankItemModel
/**
 * Model SurveySequence
 * 
 */
export type SurveySequence = Prisma.SurveySequenceModel
/**
 * Model SurveySequenceStep
 * 
 */
export type SurveySequenceStep = Prisma.SurveySequenceStepModel
/**
 * Model SurveySequenceEnrollment
 * 
 */
export type SurveySequenceEnrollment = Prisma.SurveySequenceEnrollmentModel
/**
 * Model SurveySequenceStepExecution
 * 
 */
export type SurveySequenceStepExecution = Prisma.SurveySequenceStepExecutionModel
/**
 * Model PulsePromptCustomization
 * 
 */
export type PulsePromptCustomization = Prisma.PulsePromptCustomizationModel
/**
 * Model CheckInPromptCustomization
 * 
 */
export type CheckInPromptCustomization = Prisma.CheckInPromptCustomizationModel
/**
 * Model QuarterReview
 * 
 */
export type QuarterReview = Prisma.QuarterReviewModel
/**
 * Model RockReview
 * 
 */
export type RockReview = Prisma.RockReviewModel
/**
 * Model PulseReminderConfig
 * 
 */
export type PulseReminderConfig = Prisma.PulseReminderConfigModel
/**
 * Model PulseReminderSchedule
 * 
 */
export type PulseReminderSchedule = Prisma.PulseReminderScheduleModel
/**
 * Model PulseReminderIncludedUnit
 * 
 */
export type PulseReminderIncludedUnit = Prisma.PulseReminderIncludedUnitModel
/**
 * Model Event
 * 
 */
export type Event = Prisma.EventModel
/**
 * Model JobFamily
 * 
 */
export type JobFamily = Prisma.JobFamilyModel
/**
 * Model JobFamilySpecialization
 * 
 */
export type JobFamilySpecialization = Prisma.JobFamilySpecializationModel
/**
 * Model LevelTrack
 * 
 */
export type LevelTrack = Prisma.LevelTrackModel
/**
 * Model LevelDimension
 * 
 */
export type LevelDimension = Prisma.LevelDimensionModel
/**
 * Model LevelDefinition
 * 
 */
export type LevelDefinition = Prisma.LevelDefinitionModel
/**
 * Model LevelTitle
 * 
 */
export type LevelTitle = Prisma.LevelTitleModel
/**
 * Model LevelDimensionDescription
 * 
 */
export type LevelDimensionDescription = Prisma.LevelDimensionDescriptionModel
/**
 * Model CalibrationCycle
 * 
 */
export type CalibrationCycle = Prisma.CalibrationCycleModel
/**
 * Model CalibrationParticipantGrant
 * 
 */
export type CalibrationParticipantGrant = Prisma.CalibrationParticipantGrantModel
/**
 * Model CalibrationNote
 * 
 */
export type CalibrationNote = Prisma.CalibrationNoteModel
/**
 * Model LevelProposal
 * 
 */
export type LevelProposal = Prisma.LevelProposalModel
/**
 * Model BonusPeriod
 * 
 */
export type BonusPeriod = Prisma.BonusPeriodModel
/**
 * Model BonusRecord
 * 
 */
export type BonusRecord = Prisma.BonusRecordModel
/**
 * Model TodayBrief
 * 
 */
export type TodayBrief = Prisma.TodayBriefModel
/**
 * Model CronJobRun
 * 
 */
export type CronJobRun = Prisma.CronJobRunModel
/**
 * Model PlatformAuditLog
 * 
 */
export type PlatformAuditLog = Prisma.PlatformAuditLogModel
/**
 * Model FieldProvenance
 * 
 */
export type FieldProvenance = Prisma.FieldProvenanceModel
/**
 * Model SyncEvent
 * 
 */
export type SyncEvent = Prisma.SyncEventModel
/**
 * Model SyncEventDailySummary
 * 
 */
export type SyncEventDailySummary = Prisma.SyncEventDailySummaryModel
/**
 * Model PipRequest
 * 
 */
export type PipRequest = Prisma.PipRequestModel
/**
 * Model Pip
 * 
 */
export type Pip = Prisma.PipModel
/**
 * Model PipMeasurable
 * 
 */
export type PipMeasurable = Prisma.PipMeasurableModel
/**
 * Model PipWeeklyReview
 * 
 */
export type PipWeeklyReview = Prisma.PipWeeklyReviewModel
/**
 * Model PipSignature
 * 
 */
export type PipSignature = Prisma.PipSignatureModel
/**
 * Model PipActivity
 * 
 */
export type PipActivity = Prisma.PipActivityModel
/**
 * Model Certification
 * 
 */
export type Certification = Prisma.CertificationModel
/**
 * Model AttendanceRecord
 * 
 */
export type AttendanceRecord = Prisma.AttendanceRecordModel
/**
 * Model Assessment
 * 
 */
export type Assessment = Prisma.AssessmentModel
/**
 * Model AssessmentSection
 * 
 */
export type AssessmentSection = Prisma.AssessmentSectionModel
/**
 * Model AssessmentItem
 * 
 */
export type AssessmentItem = Prisma.AssessmentItemModel
/**
 * Model AssessmentResponse
 * 
 */
export type AssessmentResponse = Prisma.AssessmentResponseModel
/**
 * Model AssessmentAccommodation
 * 
 */
export type AssessmentAccommodation = Prisma.AssessmentAccommodationModel
/**
 * Model MeetingOccurrence
 * 
 */
export type MeetingOccurrence = Prisma.MeetingOccurrenceModel
/**
 * Model MeetingAttendee
 * 
 */
export type MeetingAttendee = Prisma.MeetingAttendeeModel
/**
 * Model MeetingShare
 * One person the meeting record was SENT to, and when (#13814, canvas E2).
 * 
 * ## Why the send needs a row at all
 * 
 * Sharing is not idempotent by nature and a double click must not send
 * twice. The `@@unique` below is what makes it idempotent — the writer
 * inserts with `skipDuplicates`, so the second of two concurrent clicks
 * claims zero rows and dispatches zero notifications. A disabled button is
 * not a concurrency control (the same argument `MeetingShare`'s sibling
 * write, `acceptMeetingRecordItem`, makes about its conditional
 * `updateMany`).
 * 
 * It is also the roster's memory: the dialog can say who already has this,
 * which is the difference between "send to 3" and mailing the same six
 * people every time somebody opens the record.
 * 
 * ## APPEND-ONLY, and no `revokedAt` column
 * 
 * There is deliberately no revocation column, because there is nothing a
 * revocation could withdraw. The email has already been delivered and
 * carries the summary in its body, and the link is not a capability — it is
 * the ordinary `/meetings/{id}` URL behind the district's own sign-in, whose
 * authorization is re-evaluated against org membership on every request
 * (Decision 03 of #13791 is dissolved for exactly this reason). A "Revoke"
 * control would be a promise the product cannot keep, and a column nothing
 * writes is worse than no column: the next reader takes it for a feature.
 * 
 * Retention follows from the same fact. The link carries no token and no
 * expiry, so the share row's retention is the MEETING's — `onDelete:
 * Cascade` on the occurrence, and nothing else.
 */
export type MeetingShare = Prisma.MeetingShareModel
/**
 * Model MeetingAgenda
 * An org-owned, admin-authored agenda template (ADR-0106 § 1).
 */
export type MeetingAgenda = Prisma.MeetingAgendaModel
/**
 * Model MeetingAgendaSection
 * One ordered section of a template. ADR-0106 § 3 keeps `id`, `slug` and
 * `label` deliberately separate: `id` is the permanent FK target, `slug` is
 * the URL segment and survives renames, `label` is freely editable display
 * text the terminology layer may rewrite.
 */
export type MeetingAgendaSection = Prisma.MeetingAgendaSectionModel
/**
 * Model MeetingSection
 * The PER-OCCURRENCE SNAPSHOT (ADR-0106 § 2). Same shape as
 * `MeetingAgendaSection`, owned by the meeting, never edited by a template
 * change — and carrying no pointer back to the agenda it was copied from, so
 * there is nothing for a later template edit to reach.
 */
export type MeetingSection = Prisma.MeetingSectionModel
/**
 * Model MeetingPrivateNote
 * 
 */
export type MeetingPrivateNote = Prisma.MeetingPrivateNoteModel
/**
 * Model MeetingSummary
 * MeetingSummary — the persisted summary of one meeting (#13807, canvas C1).
 * 
 * PERSISTED, NOT REGENERATED PER PAGE VIEW. The record page, the follow-up
 * email, the chat panel's opening context and the share surface all lead with
 * the same paragraph, and three independently generated summaries of one
 * meeting is a correctness problem rather than a cost one.
 * 
 * THERE IS NO COLUMN FOR ANY OF THE THREE COUNTS, and there must not be one.
 * Action items, how many still need confirming, and decisions are arithmetic
 * over the item list (`deriveMeetingSummaryCounts` in
 * `src/lib/meetings/meeting-summary-model.ts`), derived at read time so that
 * accepting an item updates "2 need confirming" with no second write and no
 * way for a stored number to disagree with the list beneath it.
 * 
 * KEYED ON THE NOTE, NOT THE RECORDING AND NOT THE OCCURRENCE (#14238,
 * ADR-0112 § 1: artifact on Note, run on Meeting). The notes-only case — a
 * meeting nobody recorded — is a first-class input combination, and it has
 * no `Recording` row to hang off; a recording with no meeting is the other
 * one, and it has no occurrence. The note is the one thing both have. The
 * model keeps its `MeetingSummary` name because renaming it is not
 * mechanical (the table, the RLS policy, the manifest and every reader
 * would move with it); the KEY is what changed.
 */
export type MeetingSummary = Prisma.MeetingSummaryModel
/**
 * Model ObservationCycleNote
 * 
 */
export type ObservationCycleNote = Prisma.ObservationCycleNoteModel
/**
 * Model KynetaMeta
 * 
 */
export type KynetaMeta = Prisma.KynetaMetaModel
/**
 * Model KynetaRecord
 * 
 */
export type KynetaRecord = Prisma.KynetaRecordModel
/**
 * Model KynetaStoreMeta
 * 
 */
export type KynetaStoreMeta = Prisma.KynetaStoreMetaModel
/**
 * Model DisciplineIncident
 * 
 */
export type DisciplineIncident = Prisma.DisciplineIncidentModel
/**
 * Model StudentDisciplineIncidentAssociation
 * 
 */
export type StudentDisciplineIncidentAssociation = Prisma.StudentDisciplineIncidentAssociationModel
/**
 * Model DisciplineAction
 * 
 */
export type DisciplineAction = Prisma.DisciplineActionModel
/**
 * Model BehaviorIncident
 * 
 */
export type BehaviorIncident = Prisma.BehaviorIncidentModel
/**
 * Model StudentDemographic
 * 
 */
export type StudentDemographic = Prisma.StudentDemographicModel
/**
 * Model StudentRace
 * 
 */
export type StudentRace = Prisma.StudentRaceModel
/**
 * Model AcademicTerm
 * 
 */
export type AcademicTerm = Prisma.AcademicTermModel
/**
 * Model LinearWorkspaceConnection
 * 
 */
export type LinearWorkspaceConnection = Prisma.LinearWorkspaceConnectionModel
/**
 * Model GoogleCalendarConnection
 * 
 */
export type GoogleCalendarConnection = Prisma.GoogleCalendarConnectionModel
/**
 * Model GoogleGmailConnection
 * 
 */
export type GoogleGmailConnection = Prisma.GoogleGmailConnectionModel
/**
 * Model SchoolCalendar
 * 
 */
export type SchoolCalendar = Prisma.SchoolCalendarModel
/**
 * Model SchoolCalendarDate
 * 
 */
export type SchoolCalendarDate = Prisma.SchoolCalendarDateModel
/**
 * Model Course
 * 
 */
export type Course = Prisma.CourseModel
/**
 * Model CourseSection
 * 
 */
export type CourseSection = Prisma.CourseSectionModel
/**
 * Model SectionRoster
 * 
 */
export type SectionRoster = Prisma.SectionRosterModel
/**
 * Model StudentAcademicRecordGrade
 * 
 */
export type StudentAcademicRecordGrade = Prisma.StudentAcademicRecordGradeModel
/**
 * Model CalendarEvent
 * 
 */
export type CalendarEvent = Prisma.CalendarEventModel
/**
 * Model CalendarEventAttendee
 * 
 */
export type CalendarEventAttendee = Prisma.CalendarEventAttendeeModel
/**
 * Model CalendarEventContribution
 * 
 */
export type CalendarEventContribution = Prisma.CalendarEventContributionModel
/**
 * Model CalendarSyncState
 * 
 */
export type CalendarSyncState = Prisma.CalendarSyncStateModel
/**
 * Model CalendarWatchChannel
 * 
 */
export type CalendarWatchChannel = Prisma.CalendarWatchChannelModel
/**
 * Model CalendarSelection
 * 
 */
export type CalendarSelection = Prisma.CalendarSelectionModel
/**
 * Model Board
 * 
 */
export type Board = Prisma.BoardModel
/**
 * Model BoardWidget
 * 
 */
export type BoardWidget = Prisma.BoardWidgetModel
/**
 * Model BoardColumn
 * 
 */
export type BoardColumn = Prisma.BoardColumnModel
/**
 * Model TagGroup
 * 
 */
export type TagGroup = Prisma.TagGroupModel
/**
 * Model Tag
 * 
 */
export type Tag = Prisma.TagModel
/**
 * Model PulseConversationDraftItem
 * 
 */
export type PulseConversationDraftItem = Prisma.PulseConversationDraftItemModel
/**
 * Model TagAssignment
 * 
 */
export type TagAssignment = Prisma.TagAssignmentModel
/**
 * Model Priority
 * 
 */
export type Priority = Prisma.PriorityModel
/**
 * Model ValueProfile
 * The `value` kind's own attributes (#14995, ADR-0126 § 2): the rubric a
 * review rates adherence against. 1:1 with its Priority, the way
 * `SchoolProfile` hangs off `OrgUnit`. Exists if and only if the Priority's
 * `kind` is `value` — see `validatePrioritySatellites`.
 */
export type ValueProfile = Prisma.ValueProfileModel
/**
 * Model PracticeProfile
 * A `practice` offered to the rest of the organization (#16158, ADR-0126
 * § 2 satellites): how to ask for it. A practice with a row is a service and
 * shows under its unit's "What we offer"; one without is not.
 * 
 * `intakeKind` is one of PRACTICE_INTAKE_KINDS (`request` | `link` | `none`,
 * `src/lib/practice-profile-model.ts`, ADR-0107 — no Postgres enum):
 * - `request`: an in-app request, `intakeTemplateId`'s questions, sent to
 * the captain through the pulse-request machinery;
 * - `link`: an external form or portal, `intakeUrl` (http(s) only);
 * - `none`: "Ask <captain>" in AI Chat.
 * The promise is not stored here: it is the practice's target on a measure
 * (`OutcomeTarget`). Only ever on a `practice` — the write path
 * (`src/lib/practice-profile.ts`) checks the kind in the same transaction.
 */
export type PracticeProfile = Prisma.PracticeProfileModel
/**
 * Model MeasureProfile
 * The `measure` kind's own attributes (#14995, ADR-0126 § 2, § 7): the
 * yardstick's source link, direction, unit, precision and sync
 * configuration. A target is NOT here — it is an `OutcomeTarget` edge on the
 * outcome that commits to it. Exists if and only if the Priority's `kind` is
 * `measure` — see `validatePrioritySatellites`.
 */
export type MeasureProfile = Prisma.MeasureProfileModel
/**
 * Model MeasureReading
 * A measure's reading (#15016, ADR-0126 § 7): the satellite of one
 * `Evidence{kind: 'measure_reading'}` row, carrying what the Evidence's
 * prose cannot — the number, the date it is AS OF, and the measure it reads.
 * 
 * The Evidence is the provenance (who or what recorded it, under which
 * `Pulse`, with which source and citation); this row is the shape a data
 * sync writes into later, and what a chart or a target's progress reads.
 * The legacy backfill (`scripts/migration/backfill-measurables.ts`) carries
 * every `DataPoint` and `UpdateMeasurableValue` into it, so history is not
 * lost when the Measurable tables drop.
 * 
 * `measureId` is a `measure` Priority — the writer's invariant (the
 * backfill reads it off the bridged measure); it is an FK, not a kind CHECK,
 * like every other edge onto `priorities`. `value` is NULL when the legacy
 * reading was not a number (a STATUS or TEXT measurable): its text is the
 * Evidence's `sourceExcerpt`, and the row still dates the reading.
 */
export type MeasureReading = Prisma.MeasureReadingModel
/**
 * Model Governs
 * The scope of a constraint (#14998, ADR-0126 § 3): which part of the org a
 * `value` or `principle` governs. A value or principle with NO `Governs` row
 * is org-wide by default; an `org` row says so explicitly, a `unit` row
 * scopes it to one unit (a unit-scoped norm), a `priority` row to one
 * priority.
 * 
 * EXCLUSIVE ARC on `scopeKind`, the shape of `PulseConversation`'s subject
 * arc: `unit` sets exactly `unitId`, `priority` exactly `targetPriorityId`,
 * `org` neither. Held by the DB-level CHECK `governs_scope_arc` — Prisma 7.8
 * has no `@@check`, so it lives in the migration alone (the pattern on
 * `Evidence` / `Belief`) — and mirrored by `governsScopeSchema`.
 * 
 * `priorityId` is a `value` or `principle`; that crosses a table boundary,
 * so it is a zod refinement (`validateGovernsEndpoints`) every write path
 * runs, held by `check:priority-kind-invariants`.
 * 
 * One row per (priority, scope): three partial unique indexes, one per arc
 * leg, declared below with predicates matching the migration.
 */
export type Governs = Prisma.GovernsModel
/**
 * Model Indicates
 * A measure is how a responsibility's or outcome's health shows (#14998,
 * ADR-0126 § 3). `measureId` is a `measure`; `priorityId` a `responsibility`
 * or `outcome` — zod refinements (`validateIndicatesEndpoints`), held by
 * `check:priority-kind-invariants`. Replaces `MeasurableWorkItemLink` in a
 * later child of #14993.
 */
export type Indicates = Prisma.IndicatesModel
/**
 * Model OutcomeTarget
 * A success criterion (#14998, ADR-0126 § 3, § 7): an `outcome` commits to a
 * `measure` reaching a value. An outcome may carry several targets on the
 * same or different measures; progress is computed per row. Replaces
 * `MeasurableTarget` for outcome-attached targets in a later child of
 * #14993. Endpoint kinds are zod refinements
 * (`validateOutcomeTargetEndpoints`), held by
 * `check:priority-kind-invariants`.
 */
export type OutcomeTarget = Prisma.OutcomeTargetModel
/**
 * Model Watches
 * A responsibility's standing interest in a priority (#15084, ADR-0126 § 3):
 * the stakeholder relation. "Group B has a standing interest in this" is a
 * fact about B, not about one meeting, and it drives B's agenda pulls
 * (`watched` in the pull-spec role axis), B's members' reach to the node at
 * title-and-rating level (ADR-0127 § 1, the fifth walkable edge), B's
 * notifications and B's roll-up. A watcher is NOT a parent: legacy
 * `associatedGroupId` and stakeholder rows map here, never to
 * `PrioritySupport` (`src/lib/priority-watches-legacy-mapping.ts`).
 * 
 * `watcherPriorityId` is a `responsibility`; `priorityId` may be any kind —
 * a zod refinement (`validateWatchesEndpoints`), held by
 * `check:priority-kind-invariants`. Immutable: a watch is added or removed,
 * never edited, so there is no `updatedAt`.
 */
export type Watches = Prisma.WatchesModel
/**
 * Model Reviews
 * Which principles a review practice reviews (#15957): the graph link a
 * scorecard's recipe reads (`scope: 'reviewed'`, src/lib/meetings/pull-spec.ts)
 * instead of an id array inside a section config. A `practice` reviews a
 * `principle`, both in the row's org; the ends' kinds are held by
 * `validateReviewsEndpoints` (src/lib/practice-reviews-model.ts), which every
 * writer runs, since a row does not carry its endpoints' kinds. Not a
 * `PrioritySupport`: a principle does not support its review.
 */
export type Reviews = Prisma.ReviewsModel
/**
 * Model AgendaItem
 * An item on one meeting run's agenda (#15009, ADR-0126 § 6): the agenda
 * half of what a legacy `Issue` fused together. The problem is a `blocker`
 * Belief, the resolution a `decision` Belief; this row is the meeting
 * deciding to spend time on one of them.
 * 
 * EXCLUSIVE ARC on the target: exactly one of `priorityId` (a priority up
 * for review), `beliefId` (a blocker or other reading to work through) and
 * `measurePriorityId` (a measure to check). Held by the DB-level CHECK
 * `agenda_items_target_arc` — Prisma 7.8 has no `@@check`, so it lives in
 * the migration alone, as on `governs` — and mirrored by
 * `agendaItemTargetSchema` in `src/lib/agenda/agenda-vocabulary.ts`.
 * 
 * `band` and `disposition` are TEXT with the closed lists in TypeScript
 * (`AGENDA_BANDS`, `AGENDA_DISPOSITIONS`, ADR-0107).
 */
export type AgendaItem = Prisma.AgendaItemModel
/**
 * Model AgendaVote
 * Votes on one agenda item (#15009). One row per voter; a NULL `personId`
 * is the room's uncounted votes — a show of hands — which replaces
 * `meeting_issue_vote_tallies.additionalVotes`. At most one room row per item,
 * held by its derivable id (`agendaRoomVoteId`), not by an index: a plain
 * unique treats NULLs as distinct.
 */
export type AgendaVote = Prisma.AgendaVoteModel
/**
 * Model RatingRound
 * A rating round (#15425): a group rates a fixed list of priorities, first
 * privately and then together. `mode` is one of RATING_ROUND_MODES (`cold`
 * hides the system's read, the evidence and the previous rating while
 * rating; `assisted` shows them) and `state` one of RATING_ROUND_STATES
 * (`open` → `revealed` → `finalized`), both in
 * src/lib/rating-rounds/rating-round-vocabulary.ts (ADR-0107: String, no
 * Postgres enum). Before reveal a rater reads only their own submissions —
 * the RESTRICTIVE `rating_submissions_rater_privacy` policy.
 */
export type RatingRound = Prisma.RatingRoundModel
/**
 * Model RatingRoundItem
 * One priority in a round, at a fixed position (the org's order — never
 * re-sorted by disagreement). The reveal stores the group's aggregate; the
 * finalize stores the official rating and the assessment Belief it wrote.
 */
export type RatingRoundItem = Prisma.RatingRoundItemModel
/**
 * Model RatingRoundRater
 * A named rater of a round. `submittedAt` is what the facilitator reads to
 * see who has submitted — never what they submitted.
 */
export type RatingRoundRater = Prisma.RatingRoundRaterModel
/**
 * Model RatingSubmission
 * One rater's rating of one item: a status, a one-line note and, with focus
 * ranking on, their rank for it (1 = focus here first). Private until the
 * round is revealed — RLS (`rating_submissions_rater_privacy`) admits a
 * row before then only to its own rater.
 */
export type RatingSubmission = Prisma.RatingSubmissionModel
/**
 * Model BeliefAuthor
 * Authorship of a group-authored Belief (#15425): the official rating a
 * round records is an assessment authored by every rater who submitted for
 * that item. `Belief.createdById` stays the person who recorded it.
 */
export type BeliefAuthor = Prisma.BeliefAuthorModel
/**
 * Model RollupSchedule
 * PulseRequest — a saved, reusable definition someone authored by chatting
 * with an agent and sends to people (#15437, ADR-0133 § 1).
 * 
 * `brief` is `{ goal, topics[], requiredQuestions[], sourceNoteIds[],
 * pullSpec? }` and `audience` is `{ personIds[], unitIds[],
 * responsibilityIds[] }`, both zod-validated on every read and write
 * (`src/lib/pulse-requests/brief.ts`). The audience is resolved at SEND time
 * into recipient rows. `destination` is one of PULSE_REQUEST_DESTINATIONS
 * (`rollup_note` | `meeting`; only `rollup_note` is built) — a `String`
 * closed in code (ADR-0107). The output template is pinned by
 * `templateId` + `templateVersion`.
 * How often roll-ups are written (#15497): the org default, a per-type
 * default (a Priority kind, or `person`) and per-item overrides. Most
 * specific wins — item, then type, then org — in
 * `src/lib/rollup-schedules/resolve.ts`, which also holds the built-in
 * defaults an org with no rows resolves to (the #15420 per-kind map).
 * 
 * `targetType` is `org`, a Priority kind or `person` and `cadence` one of
 * ROLLUP_CADENCES — closed lists in `src/lib/rollup-schedules/vocabulary.ts`
 * (ADR-0107). `targetId` is null on the org row and on a type row, and is
 * the Priority's or person's id on an item override; it has no FK, because
 * it names either. A Priority's override is matched by id across kinds, so
 * it survives a kind change. `cadence` is null only on a type row: "follow
 * the org default". `anchorDay` is a weekday (0 = Sunday) for weekly and
 * every-two-weeks, a day of the month (1-28) for monthly, null for daily.
 */
export type RollupSchedule = Prisma.RollupScheduleModel
/**
 * Model ExampleContentApplication
 * Example content a platform admin seeded into an org (#15592): one SET
 * (`setKey`) delivered to one RECIPIENT as their own private copy. Applied
 * per org, delivered per person — the Platform Admin org page's Example
 * content tab applies a set to the org's leaders and members, and "Give to
 * person" to one person later. The copies point back here
 * (`Note.exampleContentApplicationId`), so a whole application is removed at
 * once.
 * 
 * ONE LIVE APPLICATION per (org, set, recipient): applying the same set to
 * the same person again is a no-op. Held by the writer under a transaction
 * advisory lock rather than a partial unique index, because a removed
 * application (`removedAt` set) stays as the record and the same set may be
 * applied again after it.
 */
export type ExampleContentApplication = Prisma.ExampleContentApplicationModel
/**
 * Model SavedView
 * A saved view on `/priorities` (#15033): a lens and its filter state,
 * under a name. Org views (`ownerId` null) are listed to everyone; a
 * personal view is its owner's, and opens for anyone in the org by its link
 * when `isShared`. Each org has three seeded org views (`seedKey`).
 */
export type SavedView = Prisma.SavedViewModel
/**
 * Model ViewItemOrder
 * A priority's hand-set rank in one saved view (#15036, part of #14993).
 * 
 * Rank is communicated in two places: under a parent
 * (`PrioritySupport.position`) and in a curated list — this. Everywhere
 * else a list sorts by the computed `Priority.impactScore`. A view sorts
 * the priorities it has a row for by `position`, ascending, then every
 * other one by score, descending (`sortPriorityRows`' `rank` sort).
 * 
 * Written only by `reorderSavedViewItems` (src/app/actions/saved-views.ts),
 * which rewrites the whole order of the priorities the caller can see in
 * one transaction — so `position` is not unique: a tie is never written,
 * and a row for a priority the caller cannot see keeps its relative place
 * after the ones they ranked.
 */
export type ViewItemOrder = Prisma.ViewItemOrderModel
/**
 * Model PulseRequest
 * 
 */
export type PulseRequest = Prisma.PulseRequestModel
/**
 * Model PulseRequestLayer
 * PulseRequestLayer — one unit's layer on the org weekly pulse practice
 * (#15501, `src/lib/pulse-requests/layers.ts`). It ADDS to the request's
 * brief for the people in the unit and every unit beneath it: a goal,
 * topics, required questions (fields of the request's own template) and an
 * extra pull spec, as `additions` (`storedLayerSchema` less the unit name,
 * re-parsed on every read). Layers append, most specific last, and never
 * remove. One per (request, unit); cascades with either.
 */
export type PulseRequestLayer = Prisma.PulseRequestLayerModel
/**
 * Model PulseRequestSend
 * PulseRequestSend — one time a request went out (#15437, ADR-0133 § 1, § 9).
 * 
 * A snapshot: the recipients were resolved from the audience when it was
 * sent, and editing the definition afterwards changes the next send, not
 * this one. Reminders are per send — on by default, every
 * `reminderEveryDays` days, at most `reminderMax` times. `status` is one of
 * PULSE_REQUEST_SEND_STATUSES (`open` | `closed`, ADR-0107). The roll-up
 * note is the send's tracking surface on `/notes/[id]`.
 */
export type PulseRequestSend = Prisma.PulseRequestSendModel
/**
 * Model PulseRequestSendRollup
 * PulseRequestSendRollup — one roll-up note a send owns, keyed by the
 * person it is scoped to (#15502, `src/lib/pulse-requests/team-rollups.ts`).
 * 
 * `kind` is one of PULSE_REQUEST_SEND_ROLLUP_KINDS (ADR-0107): `requester`
 * (the requester's one roll-up, #15439), `manager` (a manager's roll-up of
 * their direct reports' responses — a manager's own response goes into
 * THEIR manager's) or `captain` (the practice captain's org-level roll-up
 * of the managers' roll-ups). One per (send, kind, person); the note is
 * the person's own private roll-up, and cascades with the send, the
 * person and the note. Replaces `PulseRequestSend.rollupNoteId`
 * (expand-contract).
 */
export type PulseRequestSendRollup = Prisma.PulseRequestSendRollupModel
/**
 * Model PulseRequestRecipient
 * PulseRequestRecipient — one person asked in one send (#15437, ADR-0133
 * § 1). `status` is one of PULSE_REQUEST_RECIPIENT_STATUSES: `invited` →
 * `started` → `completed`, or `declined` from either open state (ADR-0107,
 * transitions in `src/lib/pulse-requests/recipient-state.ts`). A declined or
 * completed recipient is never reminded. `pulseId` / `noteId` are what the
 * response produced.
 */
export type PulseRequestRecipient = Prisma.PulseRequestRecipientModel
/**
 * Model PracticeRecord
 * PracticeRecord — the record of one practice run for one subject (#16012,
 * ADR-0136 Decision 3): binds the record NOTE (a private note of the owner
 * whose inputs are the run's response notes) and the record RESPONSE (a
 * `TemplateResponse` with `sourceKind = 'record'` and `sourceId` = this row,
 * filling the run's pinned template copy). One per `(sendId,
 * subjectPersonId)`. Written only through `src/lib/practice-records/`.
 * 
 * `state` is one of PRACTICE_RECORD_STATES (`draft` → `finalised` →
 * `shared` → `signed`, ADR-0107): workflow stages, not locks — every edit
 * at every state is allowed and mints the next `version`, with a
 * `PracticeRecordRevision`. `standing` is one of PRACTICE_RECORD_STANDINGS
 * (`official` | `informational`). The owner and approver are snapshotted
 * at creation. `approvedVersion` is the version the approver approved; a
 * later edit leaves it behind, so finalising needs the approver again.
 * `importedFrom` (`{ table, id }`) and `legacySnapshot` are for the E
 * issues' cutovers (Decision 6) and null on a live record.
 * 
 * Every reference INTO the record's rows is RESTRICT: deleting the send,
 * the note, the response (and so its template copy) or a person a record
 * names is refused, so no cascade removes a record before the retention
 * decision says it may.
 */
export type PracticeRecord = Prisma.PracticeRecordModel
/**
 * Model PracticeRecordRevision
 * PracticeRecordRevision — one change to a practice record (#16012,
 * ADR-0136 Decision 3): an edit of the record response's values, a state
 * transition, an approval or a signature. `kind` is one of
 * PRACTICE_RECORD_REVISION_KINDS (ADR-0107). `version` is the record's
 * version after the change. `changes` is the field-level diff, an array of
 * `{ field, before, after }` (`src/lib/practice-records/diff.ts`); every
 * value a version held lives in these entries, so a redaction
 * (`redactPracticeRecordField`) rewrites them in every revision and
 * appends `{ field, redactedAt, redactedById, authority }` to
 * `redactions`. `reason` is required once the record has been shared.
 * `impersonatedById` is the real actor when the author was viewed-as.
 * Never deleted: cascades only with its record.
 */
export type PracticeRecordRevision = Prisma.PracticeRecordRevisionModel
/**
 * Model PracticeRecordSignature
 * PracticeRecordSignature — one signer's act on one version of a practice
 * record (#16012, ADR-0136 Decision 3). `kind` is one of
 * PRACTICE_RECORD_SIGNATURE_KINDS (`signed` = acknowledged, with an
 * optional `comment`; `declined`, with a `reason`; `attested`, recorded by
 * `attestedById` for a signer with no login or on paper). `party` is the
 * signer's part in the record (PRACTICE_RECORD_SIGNER_PARTIES). A signature
 * names the `version` it signed and is NEVER voided or updated: a later
 * edit leaves it in place ("signed version 3; current is version 5") and
 * the signer may sign again, which is a new row. `impersonatedById` is the
 * real actor when the signer was viewed-as (#5806's rule).
 */
export type PracticeRecordSignature = Prisma.PracticeRecordSignatureModel
/**
 * Model PracticeRunSynthesis
 * PracticeRunSynthesis — the AI synthesis of one subject's party responses
 * in one practice run, for one AUDIENCE (#16011, ADR-0136 Decision 2).
 * 
 * A synthesis is generated per audience, because hiding a party's response
 * does not hide content a summary repeats: `audienceKey` is the SHA-256 of
 * the sorted ids of the confirmed responses it was generated over, so a
 * viewer is shown it only when the responses they may read
 * (`resolvePracticeAccess`) are exactly those. `basedOn` lists them
 * (`[{ responseId, party, updatedAt }]`) so a later edit marks it out of
 * date. `content` is the labelled AI output (`src/lib/practices/
 * run-synthesis.ts`): a summary, where the parties agree and differ — each
 * point citing parties by role — and an AI second opinion per field, whose
 * values carry an AI origin and enter the record only when its owner
 * accepts one. No `Person` stands for the model: the AI is never a party.
 * 
 * Tenant RLS only. The access predicate is NOT encoded in RLS: the reader
 * function is the only read path (ADR-0136 Decision 5, decided here).
 */
export type PracticeRunSynthesis = Prisma.PracticeRunSynthesisModel
/**
 * Model PracticeAssignment
 * PracticeAssignment — a standing instruction that a reviewer reviews certain
 * subjects in a practice, as a party, officially or informationally (#16010,
 * ADR-0136 Decision 1).
 * 
 * Feedback about anyone is open (ADR-0133 § 4 holds): an assignment is what
 * makes it OFFICIAL. Only three roles may create an `official` one — the org
 * admin, a unit leader for their unit, and the practice's captain within its
 * subject audience (`src/lib/practices/assignments.ts`). Anyone in the org
 * may create an `informational` one.
 * 
 * The subjects are an explicit list (`subjectPersonIds`) or a rule resolved
 * at each run (`subjectRule`, one of `PRACTICE_SUBJECT_RULES`: members of
 * `subjectUnitId`, the reviewer's direct reports, the reviewer's mentees).
 * `party`, `standing` and `subjectRule` are `String` columns closed in
 * TypeScript (`src/lib/practices/vocabulary.ts`, ADR-0107). `events` is the
 * assignment's event log, appended by its one writer.
 * 
 * `orgId` has NO `@default` (#11901, ADR-0023).
 */
export type PracticeAssignment = Prisma.PracticeAssignmentModel
/**
 * Model Evidence
 * 
 */
export type Evidence = Prisma.EvidenceModel
/**
 * Model EvidenceCitation
 * 
 */
export type EvidenceCitation = Prisma.EvidenceCitationModel
/**
 * Model Belief
 * 
 */
export type Belief = Prisma.BeliefModel
/**
 * Model Pulse
 * 
 */
export type Pulse = Prisma.PulseModel
/**
 * Model PrioritySupport
 * 
 */
export type PrioritySupport = Prisma.PrioritySupportModel
/**
 * Model BeliefEvidence
 * 
 */
export type BeliefEvidence = Prisma.BeliefEvidenceModel
/**
 * Model GraphConsolidationRun
 * 
 */
export type GraphConsolidationRun = Prisma.GraphConsolidationRunModel
/**
 * Model EvidenceClassificationChange
 * 
 */
export type EvidenceClassificationChange = Prisma.EvidenceClassificationChangeModel
/**
 * Model OrgClassificationDefault
 * 
 */
export type OrgClassificationDefault = Prisma.OrgClassificationDefaultModel
/**
 * Model OrgClassificationDefaultChange
 * 
 */
export type OrgClassificationDefaultChange = Prisma.OrgClassificationDefaultChangeModel
/**
 * Model GraphConsolidationChange
 * 
 */
export type GraphConsolidationChange = Prisma.GraphConsolidationChangeModel
/**
 * Model BeliefClaimEdge
 * 
 */
export type BeliefClaimEdge = Prisma.BeliefClaimEdgeModel
/**
 * Model BeliefResolution
 * 
 */
export type BeliefResolution = Prisma.BeliefResolutionModel
/**
 * Model BeliefLink
 * 
 */
export type BeliefLink = Prisma.BeliefLinkModel
/**
 * Model PulseParticipant
 * 
 */
export type PulseParticipant = Prisma.PulseParticipantModel
/**
 * Model PriorityOrgUnit
 * 
 */
export type PriorityOrgUnit = Prisma.PriorityOrgUnitModel
/**
 * Model PersonRelationship
 * 
 */
export type PersonRelationship = Prisma.PersonRelationshipModel
/**
 * Model SimulationRun
 * 
 */
export type SimulationRun = Prisma.SimulationRunModel
/**
 * Model SimulationPeriod
 * 
 */
export type SimulationPeriod = Prisma.SimulationPeriodModel
/**
 * Model PriorityPlanMembership
 * 
 */
export type PriorityPlanMembership = Prisma.PriorityPlanMembershipModel
/**
 * Model PriorityAssignment
 * PriorityAssignment — the ONE way a person is attached to a Priority
 * (Issue #14996, ADR-0126 § 3). The renamed owner edge #14239 added
 * (ADR-0112 § 5), shaped after `UnitAssignment`: a closed `role`, a
 * bi-temporal `effectiveFrom` / `effectiveTo` window, and partial uniques on
 * the open rows.
 * 
 * A typed edge table, never a column on `Priority`: an assignment is a fact
 * about a person and a priority together rather than an attribute of
 * either. `Priority.createdById` stays what it always was — who wrote the
 * row — and is not an assignment.
 * 
 * WRITERS. `src/lib/priority-assignments.ts` is the only module that
 * creates, closes or reopens a row (`setCaptain`, `claimOwnership`,
 * `addContributor`, `removeContributor`, `addObserver`, `removeObserver`);
 * a raw `create` on
 * this table anywhere else is a defect, and
 * `tests/unit/lib/priority-assignment-writers-14996.test.ts` fails on one.
 * A change is a CLOSE plus an OPEN, never an update of `personId`: the
 * closed row is the history `captainAsOf` reads.
 * 
 * `role` is a plain `String` closed in code (`PRIORITY_ASSIGNMENT_ROLES` in
 * `src/lib/priority-assignment-roles.ts`, ADR-0107).
 */
export type PriorityAssignment = Prisma.PriorityAssignmentModel
/**
 * Model PriorityExtractedItem
 * PriorityExtractedItem — the minted-from edge (Issue #14239, ADR-0112 § 5):
 * the note-taker `ExtractedItem` whose ACCEPT minted this `Priority`.
 * 
 * A typed edge table in the shape of `PriorityAssignment` / `PriorityOrgUnit`,
 * never a column on either side: ADR-0112 § 5 (and ADR-0099 § 7) keep
 * note-taker-specific columns off `Priority`, and ADR-0104 § 1 forbids
 * extending `ExtractedItem` with columns.
 * 
 * Readers — the rail's checkbox, the record card, the next meeting's brief —
 * resolve the minted Priority through this edge and never by `BeliefLink`
 * order: a person can hand-link the same reading to any other Priority on
 * `/priorities/evidence`, and an item accepted with no linkable reading has
 * no link at all.
 * 
 * Strictly 1:1: both FKs are `@unique`. The one on `extractedItemId` is
 * what makes a double accept race-safe — a second mint for the same item
 * fails its transaction instead of writing a twin. Both sides `Cascade`:
 * deleting the item removes the EDGE, never the person's Priority.
 */
export type PriorityExtractedItem = Prisma.PriorityExtractedItemModel
/**
 * Model PriorityEvidence
 * PriorityEvidence — the minted-from edge on the GRAPH side (#13949,
 * ADR-0104 § 2, ADR-0112 § 5): the `Evidence` reading whose ACCEPT minted
 * this `Priority`.
 * 
 * The exact mirror of `PriorityExtractedItem`, and deliberately not a
 * `taskId`-shaped column on `Evidence`. `ExtractedItem.taskId` is marked NO
 * LONGER WRITTEN since #14239 — accept mints a `Priority`, not a `Task` —
 * so a graph-side `Evidence.taskId` would have mirrored a dead column and
 * taught the next reader the wrong shape. What accept produces is a
 * Priority, and #14239 already decided how a reader finds it: an edge table
 * in the shape of `PriorityAssignment` / `PriorityOrgUnit`, never a column on
 * either side (ADR-0112 § 5, ADR-0099 § 7, ADR-0104 § 1).
 * 
 * The record's extraction arm resolves an accepted item's Priority through
 * THIS edge (`record-graph-items.ts`), never from `BeliefLink` order: a
 * person can hand-link the same reading to any Priority on
 * `/priorities/evidence`, and an item accepted with no linkable reading has
 * no link at all.
 * 
 * Strictly 1:1: both FKs are `@unique`. The one on `evidenceId` is what
 * makes a double accept race-safe — a second mint for the same reading
 * fails its transaction instead of writing a twin. Both sides `Cascade`:
 * deleting the reading removes the EDGE, never the person's Priority.
 * 
 * It coexists with `PriorityExtractedItem` rather than replacing it: an
 * accept writes both while ADR-0104 § 2's strangler is mid-flight, because
 * `/notetaker`'s review queue still reads the `ExtractedItem` side. Step
 * three drops that side along with the table.
 */
export type PriorityEvidence = Prisma.PriorityEvidenceModel
/**
 * Model LegacyBridge
 * 
 */
export type LegacyBridge = Prisma.LegacyBridgeModel
/**
 * Model LegacyEntityRedirect
 * 
 */
export type LegacyEntityRedirect = Prisma.LegacyEntityRedirectModel
/**
 * Model PriorityDependency
 * 
 */
export type PriorityDependency = Prisma.PriorityDependencyModel
/**
 * Model PriorityScore
 * 
 */
export type PriorityScore = Prisma.PriorityScoreModel
/**
 * Model ContextResearchRun
 * 
 */
export type ContextResearchRun = Prisma.ContextResearchRunModel
/**
 * Model ContextResearchSection
 * 
 */
export type ContextResearchSection = Prisma.ContextResearchSectionModel
/**
 * Model RosterCandidate
 * 
 */
export type RosterCandidate = Prisma.RosterCandidateModel
/**
 * Model StrategicPlan
 * The thin header for one captured strategic plan (ADR-0099 § 2). Holds only
 * what is not a Priority: title, scope, school reference, adoption, span,
 * source, status, the two graph pointers and the run that produced it.
 * 
 * The header DOES NOT EXIST BEFORE PROMOTION. Everything before that lives on
 * `StrategicPlanCandidate` rows; this row is created by the promotion, at
 * `PUBLISHED`.
 * 
 * Versioned by SUPERSESSION, which is ONE time axis and not bi-temporality:
 * `spanStart`/`spanEnd`/`adoptedOn` are data about the document, not a
 * transaction-time axis over the row. Do not add `validFrom`/`validTo`.
 */
export type StrategicPlan = Prisma.StrategicPlanModel
/**
 * Model StrategicPlanCandidate
 * A staged plan node extracted from a published document, held OUTSIDE the
 * Priority graph until an explicit, reviewed promotion writes the subtree
 * (ADR-0099 § 5 — the same blast-radius limiter ADR-0067 chose for
 * `InferenceCandidate`: the model never writes the graph directly).
 * 
 * Mirrors `RosterCandidate`, which is the other "extracted, not yet
 * admitted" staging table in this schema.
 */
export type StrategicPlanCandidate = Prisma.StrategicPlanCandidateModel
/**
 * Model StrategicPlanNodeEdit
 * An ORG ADMIN's correction to one promoted plan node (Issue #13634,
 * ADR-0099 § 7).
 * 
 * ## Why the corrected value needs a table at all
 * 
 * `loadPlanBranch` reads a node's `statement`, `focusTags` and `sourceUrl`
 * off `StrategicPlanCandidate` — the extraction STAGING row — not off the
 * `Priority`. So a correction has exactly three possible homes, and two of
 * them are unusable:
 * 
 * the candidate row — it is the baseline `plan-diff.ts` computes the next
 * re-run against, so writing the correction there makes the next capture
 * compare the document to itself and report "unchanged". It is also
 * absent entirely for an operator-uploaded plan, which has no run and
 * therefore no candidates: that plan could not be corrected at all.
 * three more columns on `priorities` — rejected by ADR-0099 § 7, for the
 * third time across three ADRs. See `Priority.planNodeKind`'s own
 * docstring, which says so in the schema.
 * HERE — the document's words stay verbatim on the candidate, the human's
 * correction sits in its own row, and the two are never conflated. That
 * separation IS what § 7 asks for; `FieldProvenance` records WHICH
 * fields were overridden so a re-run parks rather than clobbers, and it
 * stores no values of its own.
 * 
 * ## What `editedFields` is for
 * 
 * "Cleared to no tags" and "never corrected" are different facts, and a
 * `String[]` cannot be null. `editedFields` names which of
 * `statement` | `focusTags` | `sourceUrl` this row actually claims;
 * everything else falls through to the document. Vocabulary in
 * `src/lib/strategic-plans/plan-edit-validation.ts`, per #13444 — enumerated
 * vocabularies live in code, not in the database.
 */
export type StrategicPlanNodeEdit = Prisma.StrategicPlanNodeEditModel
/**
 * Model ContextSource
 * 
 */
export type ContextSource = Prisma.ContextSourceModel
/**
 * Model ContextSourceChunk
 * One searchable piece of a source's parsed text (#16123), following the
 * `NoteSearchChunk` pattern: the extracted text of a link, an uploaded file
 * or a pasted text is KEPT here, rather than discarded after summarizing, so
 * the `search_sources` / `read_source` tools can answer from it.
 * 
 * Derived, never edited: replacing a source (a new upload, a re-fetch, new
 * pasted text) deletes its chunks and writes them again in one transaction
 * (`replaceContextSourceChunks`). No version history in v1.
 * 
 * `searchVector` is written by that writer as
 * `to_tsvector('english', text)`, not a generated column; its GIN index is
 * raw DDL Prisma cannot declare over an `Unsupported` column, carved out in
 * `src/lib/schema-index-expression-orphan-carve-outs.ts`.
 * 
 * `orgId` has NO `@default` (#11901, ADR-0023).
 */
export type ContextSourceChunk = Prisma.ContextSourceChunkModel
/**
 * Model WelcomeLeader
 * 
 */
export type WelcomeLeader = Prisma.WelcomeLeaderModel
/**
 * Model ConversationArtifact
 * 
 */
export type ConversationArtifact = Prisma.ConversationArtifactModel
/**
 * Model ActionBoardIntervention
 * 
 */
export type ActionBoardIntervention = Prisma.ActionBoardInterventionModel
/**
 * Model TodayFocusSteeringSignal
 * 
 */
export type TodayFocusSteeringSignal = Prisma.TodayFocusSteeringSignalModel
/**
 * Model TodayFocusProfileSuppression
 * 
 */
export type TodayFocusProfileSuppression = Prisma.TodayFocusProfileSuppressionModel
/**
 * Model SaiWeeklyRollup
 * One row per week in a window: the sessions spine every other table's
 * totals are cross-checked against.
 */
export type SaiWeeklyRollup = Prisma.SaiWeeklyRollupModel
/**
 * Model SaiBreadthCell
 * Grade band × subject session counts for a window — the breadth heat grid.
 * Cells sum to the window's weekly session total; the seed asserts it and
 * `fold.ts` surfaces the disagreement rather than hiding it.
 */
export type SaiBreadthCell = Prisma.SaiBreadthCellModel
/**
 * Model SaiSignalRollup
 * The student-signal ladder: one row per grade band per window, holding the
 * five band counts and the covered-session denominator they sum to.
 * 
 * WHY FIVE COLUMNS AND NOT FIVE ROWS. The invariant the board depends on is
 * "the bands sum to coveredSessions". As columns that is a single-row check
 * the seed and the fold can both make; as rows it is a GROUP BY that can be
 * silently half-written. The vocabulary is closed by the product (the ladder
 * IS the five bands), so the usual argument for rows does not apply.
 */
export type SaiSignalRollup = Prisma.SaiSignalRollupModel
/**
 * Model SaiAlertRollup
 * Safety-alert themes for a window, already k-anonymised at write time.
 */
export type SaiAlertRollup = Prisma.SaiAlertRollupModel
/**
 * Model SaiEducatorCohortRollup
 * Educator support cohorts, per grade band.
 * 
 * ALWAYS PER GRADE BAND, never a bare cohort total. The board's one
 * cross-card insight is "five of the six who paused teach grade 7", and a
 * schema that stored the cohort total beside a separate paused-by-grade
 * detail would store `6` twice. Cohort totals and the educator count are
 * SUMS over these rows, so the sentence cannot disagree with the bar.
 */
export type SaiEducatorCohortRollup = Prisma.SaiEducatorCohortRollupModel
/**
 * Model SaiReportImport
 * One uploaded export file. Every row table below points at exactly one of
 * these, and the newest per `(orgId, fileKind)` is what the app reads.
 */
export type SaiReportImport = Prisma.SaiReportImportModel
/**
 * Model SaiOrgMetric
 * Org-wide metrics: the usage report's `Key metrics` and `Trends by time
 * period`, and the alerts report's `Alerts overview`, `Alerts over time` and
 * `Alerts by category`. One table because they are all "one number, for one
 * group, optionally for one month" and splitting them by section would make
 * the alerts series and the usage series impossible to put on one axis.
 */
export type SaiOrgMetric = Prisma.SaiOrgMetricModel
/**
 * Model SaiSchoolMetric
 * Per-school rows: the usage report's `School rankings` and the alerts
 * report's `Alerts by school`, folded onto one grain.
 */
export type SaiSchoolMetric = Prisma.SaiSchoolMetricModel
/**
 * Model SaiTeacherMetric
 * `Teacher rankings`. Holds real names — see the block comment above before
 * adding a reader.
 */
export type SaiTeacherMetric = Prisma.SaiTeacherMetricModel
/**
 * Model SaiCatalogUsage
 * `Top tools` and `Top spaces` — the tool mix, ten rows per group per list.
 */
export type SaiCatalogUsage = Prisma.SaiCatalogUsageModel
/**
 * Model OrgUnit
 * 
 */
export type OrgUnit = Prisma.OrgUnitModel
/**
 * Model SchoolProfile
 * The EDUCATION extension of `OrgUnit`. Every education noun in this slice
 * lives here and in the adapters, never on the primitive.
 */
export type SchoolProfile = Prisma.SchoolProfileModel
/**
 * Model UnitAssignment
 * A person's assignment to a structural unit (#13413, ADR-0100 tier 1).
 * 
 * ## What it is for
 * 
 * This is the SOLE input to the tier-1 GUC resolver
 * (`src/lib/rls/unit-scope.ts`). The active rows for a person, expanded to
 * descendant units, are what `app.current_unit_ids` carries, and that GUC is
 * what every `<table>_unit_scope` restrictive policy reads. A row here is
 * therefore a grant of database-enforced visibility, not a label.
 * 
 * Org-wide scope is deliberately NOT a row here: it is
 * `OrgMembership.role` in `{ OWNER, ADMIN }` (ADR-0100 defaults to the
 * existing admin roles rather than minting a distinct org-wide staff role).
 * Adding an `isWholeOrg` row shape would give the resolver two spellings of
 * the same fact.
 * 
 * ## Who writes it
 * 
 * Ed-Fi `StaffEducationOrganizationAssignmentAssociation`, RosterStream org
 * membership and Rippling department are the feeds that will; until they do,
 * the operator writes it by hand. Either way the write goes through
 * `src/lib/org-units/assignments.ts` — ADR-0029's service-layer rule, and
 * here it is load-bearing rather than stylistic, because a write that skips
 * the reserved-id and same-org checks is a scope grant nothing reviewed.
 * 
 * ## Uniqueness: ACTIVE rows only
 * 
 * The issue asked for `@@unique([personId, unitId])` and ADR-0100 asked for
 * "partial indexes on active rows". Those are reconciled the way
 * `EnrollmentAssociation` already reconciles the same tension: the unique is
 * PARTIAL on `effectiveTo IS NULL`, so a person has at most one OPEN
 * assignment per unit while their closed history may hold many. A total
 * unique would make re-assigning someone to a unit they once led impossible
 * without deleting the record of the first stint, which is exactly the
 * history a FERPA audit asks for.
 * 
 * Consequence, stated because it bites: `personId_unitId` is one of the
 * partial-unique `WhereUniqueInput` keys Postgres does not enforce for ALL
 * rows — never use it in `findUnique`/`upsert`/`connect`/`delete`/`update`.
 * See docs/conventions/PRISMA_MIGRATIONS.md § "Client-shape consequence".
 */
export type UnitAssignment = Prisma.UnitAssignmentModel
/**
 * Model ReportsTo
 * The reporting line as an edge (#14999, ADR-0126; ADR-0100 tier 2 as
 * amended 2026-10-06). Replaces `Person.managerId`, which stays for one
 * release (expand-contract). Filled by `reports_to_resync()` (#15129) from
 * the per-org manager of record — `OrgPersonProfile.managerId`, falling back
 * to `Person.managerId` for a home org with no profile row (ADR-0105).
 * 
 * - `dimension` — WHICH reporting line: `hr`, `academic`, `advisory`. Plain
 * `String`, never a Postgres enum (ADR-0107); the closed list is
 * `REPORTS_TO_DIMENSIONS` in `src/lib/reports-to-dimensions.ts`.
 * - `authoritative` — the one line per person per dimension that grants
 * tier-2 reach. A non-authoritative (advisory) row is a recorded
 * relationship and grants nothing.
 * - `effectiveFrom` / `effectiveTo` — the valid-time window, `@db.Date`,
 * half-open: `effectiveTo` is the first day NO LONGER in force (same
 * convention as `UnitAssignment`). `createdAt` is the transaction time, so
 * "who did Sarah report to in Q2" and "what did we believe then" are both
 * answerable.
 * 
 * Readers go through `src/lib/reports-to.ts`; the tier-2 database predicate
 * is `reports_to_chain_contains()` / `current_person_accountable_for()`.
 */
export type ReportsTo = Prisma.ReportsToModel
/**
 * Model Note
 * Note — the note taker's ARTIFACT (#14238, ADR-0112 § 1).
 * 
 * ARTIFACT ON NOTE, RUN ON MEETING. A note owns every capture's output —
 * its recordings, its summary, the items read out of them — and a
 * `MeetingOccurrence` owns only the run (agenda snapshot, phase, roster,
 * facilitator state). A summary, an item, a recording or a share that keys
 * on `MeetingOccurrence` after ADR-0112 is a defect, not a convenience.
 * 
 * A note may exist with no meeting, no recording and no calendar event: a
 * typed note, an ad-hoc capture, and later a chat- or pulse-produced note.
 * Every optional pointer below is `SetNull`, because losing the thing a note
 * came FROM must never destroy what was written in it.
 * 
 * `orgId` has NO `@default` (#11901, ADR-0023).
 */
export type Note = Prisma.NoteModel
/**
 * Model Recording
 * Recording — one capture session: what the browser produced, where the
 * object landed, and how far through the pipeline it has got.
 * 
 * `orgId` has NO `@default`. On a net-new tenant-scoped table an
 * `@default("org-…")` converts a missing-`orgId` insert from a loud failure
 * into a silent write against the live org (#11901, ADR-0023).
 */
export type Recording = Prisma.RecordingModel
/**
 * Model RecordingChunk
 * *
 *  * When one stored chunk of a recording BEGAN, relative to the capture's start
 *  * (#13939).
 *  * ## Why the timeline cannot be recovered from the audio
 *  * A live capture restarts `MediaRecorder` at every chunk boundary, so the
 *  * bytes hold nine little clocks that each start at zero and no record of where
 *  * they sat in the meeting. The transcription runner reconstructs that by
 *  * summing the decoded duration of the chunks before each one, which is close
 *  * but always short: the window between `stop()` and `start()` captures
 *  * nothing, and `pause()` can leave a gap of any size at all. Every span after
 *  * such a gap lands earlier than it was said, and the error accumulates through
 *  * the meeting — landing hardest on the end, which is where decisions get made.
 *  * Only the capturing tab knows the real offset, and only while it is still
 *  * recording. So it is written down on the way in.
 *  * ## One row per stored object, and no audio in it
 *  * This table is metadata ABOUT the objects under the recording's storage
 *  * prefix, never the audio itself. That separation is what lets it outlive the
 *  * bytes: when the retention rule expires a recording's audio the transcript
 *  * and its timeline both survive, the same way the `Recording` row outlives
 *  * the audio it describes.
 *  * ## `UPLOAD` recordings have no rows here, deliberately
 *  * An uploaded file is cut into BYTE RANGES, not time slices — its chunks are
 *  * fragments of one container with one timeline of their own, so a per-chunk
 *  * capture offset would be a fiction. `groupChunksForTranscription` reads that
 *  * mode as a single unit and never asks for an offset.
 */
export type RecordingChunk = Prisma.RecordingChunkModel
/**
 * Model LiveSummarySnapshot
 * LiveSummarySnapshot — one version of a recording's LIVE summary (#14377,
 * part of #14371).
 * 
 * While a capture is running, and with the recorder's `ai_note_processing`
 * on (#16725 retired `notetaker_live`), the live summary
 * engine (`src/lib/notetaker/live-summary-trigger.ts`) summarises the
 * FINALIZED prefix of the transcript by topic. Every run writes a NEW row
 * with the next `version`; nothing is ever updated in place, so the version
 * history is the record of how often the summary was rewritten — the eval
 * harness (#14373) measures exactly that. There is deliberately no
 * `updatedAt`.
 * 
 * `topics` is `LiveTopic[]` (`src/lib/notetaker/live-summary-fold.ts`):
 * closed topics are FROZEN and carried verbatim from version to version,
 * and every claim cites the `TranscriptSegment` ids it came from.
 * 
 * This is not the post-meeting summary. Stop leaves these rows alone and the
 * existing pipeline writes `MeetingSummary` from the full transcript.
 */
export type LiveSummarySnapshot = Prisma.LiveSummarySnapshotModel
/**
 * Model LiveExtractionWindow
 * LiveExtractionWindow — one window of LIVE item extraction (#15861).
 * 
 * While a capture is running, and with the recorder's `ai_note_processing`
 * on (#16725), the live extraction engine (`src/lib/notetaker/live-extraction-trigger.ts`) runs the
 * ordinary extraction stage over each newly finalized stretch of transcript,
 * `[fromMs, throughMs)` plus the chunk overlap, and stages what it found
 * here. Nothing reads these rows during the meeting: they are not shown.
 * When transcription succeeds, `runItemExtraction` reads them and, when they
 * cover enough of the recording (`LIVE_COVERAGE_MIN_FRACTION`), extracts only
 * the tail and folds the staged items in through the unchanged fold, which
 * re-locates every staged quote against the final transcript.
 * 
 * RETENTION: the final extraction deletes a recording's windows once it has
 * written (`src/lib/notetaker/extract-items.ts`); the composite FK cascades
 * them with the recording either way. Append-only until then, one row per
 * `version`, no `updatedAt`.
 */
export type LiveExtractionWindow = Prisma.LiveExtractionWindowModel
/**
 * Model NoteOutputFlag
 * NoteOutputFlag — a person marking a notetaker output WRONG (#14382, part
 * of #14371): a live panel line, a final summary claim, or an extracted
 * item, with a reason and an optional comment.
 * 
 * The real-examples loop. `pnpm eval:notetaker:export-flags` turns these rows
 * into eval-harness cases (`scripts/eval-harness/notetaker/export-flags.ts`),
 * and the flag rate by reason is the notetaker's trust metric.
 * 
 * A SERVER-SIDE SNAPSHOT. `targetText` and `spanIds` are copied by
 * `flagNoteOutput` from the stored output at flag time — never from the
 * request — so a flag records what the notetaker actually said and which
 * transcript it cited, and it survives the summary being regenerated.
 * 
 * `reason` and `targetKind` are `String` columns closed in TypeScript by
 * `OUTPUT_FLAG_REASONS` / `OUTPUT_FLAG_TARGET_KINDS`
 * (`src/lib/notes/note-output-flags.ts`, ADR-0107) — no Postgres enum.
 * 
 * `orgId` has NO `@default` (#11901, ADR-0023).
 */
export type NoteOutputFlag = Prisma.NoteOutputFlagModel
/**
 * Model NoteSummaryRevision
 * NoteSummaryRevision — a person's edit of a note's whole AI summary
 * (#15299). APPEND-ONLY: every Save on the summary card inserts a row, and
 * nothing updates or deletes one — not a later edit, not a regeneration of
 * the AI summary. The latest is shown while it is newer than the stored AI
 * summary (`MeetingSummary.generatedAt`); every later regeneration reads it
 * as its leading input, and it stays readable as one of the note's sources.
 * 
 * `aiBaseline` is the AI summary as it was edited from and `diff` a line diff
 * of the two, both computed by the server (`saveNoteSummaryRevision`), so the
 * rows are eval examples as they stand (`pnpm eval:notetaker:export-flags`).
 * 
 * `orgId` has NO `@default` (#11901, ADR-0023).
 */
export type NoteSummaryRevision = Prisma.NoteSummaryRevisionModel
/**
 * Model NoteThreadGist
 * The cached gist of one `/notes` subject thread (#14560).
 * 
 * Threads are DERIVED (`src/lib/notes/note-threads.ts`) — a priority, a
 * person, a meeting series or an output template the viewer's notes link —
 * and are never stored. Only the two-sentence gist read across a thread's
 * notes is, because it is one model call (the `noteThreadGist` stage, ADR-0114)
 * and a page must not make it on every render. `PatternCache` and
 * `KnowledgeGraphCache` are per-org singletons and the pulse syntheses are
 * keyed on a person and a period, so none of them is a keyed cache to reuse.
 * 
 * Read by `(orgId, threadKind, threadKey)`. The row is CURRENT while its
 * `newestNoteId`, `memberCount` and `memberDigest` match the thread being
 * rendered; otherwise the stage runs and the row is upserted. `memberDigest`
 * (a SHA-256 of the sorted member note ids) is what makes that match a
 * statement about the SAME notes: two viewers whose visible members share a
 * newest note and a count but not a set must not read each other's gist.
 * A stage failure leaves the row as it was. A row whose thread no longer
 * exists is never read; nothing sweeps it.
 * 
 * `threadKind` is a `String` closed in TypeScript by `NOTE_THREAD_KINDS`
 * (ADR-0107). `orgId` has NO `@default` (#11901, ADR-0023).
 */
export type NoteThreadGist = Prisma.NoteThreadGistModel
/**
 * Model NoteSearchChunk
 * One searchable piece of a note (#14554, the notes-search TRIAL behind the
 * `note_search` flag). DERIVED, never authored: every row is rebuilt from the
 * note's own sources by `src/lib/note-search/indexer.ts`, so dropping the
 * table loses nothing but the index.
 * 
 * `sourceKind` is a `String` closed in TypeScript by
 * `NOTE_SEARCH_SOURCE_KINDS` (`src/lib/note-search/vocabulary.ts`, ADR-0107).
 * 
 * `audienceParticipantId` IS A CONFIDENTIALITY BOUNDARY. NULL means "anyone
 * who may read the note" (`visibleNoteWhere`); set means THAT
 * `ParticipantIdentity` only — a `MeetingPrivateNote` or a private-weave
 * `MeetingSummary` — and org admins are not exempt. `Cascade` from the
 * participant, never `SetNull`: nulling it would publish the chunk.
 * 
 * `searchVector` is written BY THE INDEXER as
 * `to_tsvector(language::regconfig, text)` — deliberately not a generated
 * column, so a new `language` is a reindex rather than a migration. Its GIN
 * index (`note_search_chunks_search_vector_idx`) is raw DDL Prisma cannot
 * declare over an `Unsupported` column; it is carved out by name in
 * `src/lib/schema-index-expression-orphan-carve-outs.ts`, as
 * `rocks_search_vector_idx` is. `embedding` is `vector(512)` (not `halfvec`:
 * production's pgvector version could not be confirmed when this landed, and
 * `vector` works on every version); NULL until embedded, and for a chunk too
 * short to embed. No ANN index — the search is an exact scan inside the
 * viewer's visible notes (#14554 § Performance).
 * 
 * `orgId` has NO `@default` (#11901, ADR-0023).
 */
export type NoteSearchChunk = Prisma.NoteSearchChunkModel
/**
 * Model NoteSearchDirty
 * The note-search work queue (#14554): one row per note whose indexed
 * content changed since it was last indexed. Upserted by
 * `markNoteSearchDirty` inside the transaction of the write that changed the
 * content; claimed by the `note-search-index` cron with a conditional update
 * (`claimedAt`), and deleted once the note is indexed — unless it was
 * re-dirtied meanwhile (`enqueuedAt` moved), in which case it stays for the
 * next tick.
 * 
 * `reason` is closed by `NOTE_SEARCH_DIRTY_REASONS` (ADR-0107).
 * `orgId` has NO `@default` (#11901, ADR-0023).
 */
export type NoteSearchDirty = Prisma.NoteSearchDirtyModel
/**
 * Model NoteShare
 * NoteShare — a note shared with one org member (#14535; any shape since
 * #14736).
 * 
 * A READ grant: `visibleNoteWhere`'s share arm admits the person to the
 * note, its transcript and its audio. Editing stays with the note's creator
 * and org admins (#14446) — a share never widens the write gate.
 * 
 * `Person`, not `ParticipantIdentity` — recorded against ADR-0047. Sharing
 * grants APP access, which only an org member with a `Person` can use; an
 * accountless recipient stays on the meeting-record path (`MeetingShare`),
 * which is where the meetings layer's `ParticipantIdentity` rule applies.
 * A meeting note may carry rows since #14736: its audience is its own
 * `Note.isPrivate`, and a share admits the person to the NOTE only — never
 * to the meeting page, whose ACL is the meeting's.
 */
export type NoteShare = Prisma.NoteShareModel
/**
 * Model NoteSubject
 * NoteSubject — one person or one priority a note is ABOUT (#16108).
 * 
 * A principal's notes about a teacher, an improvement plan's notes about a
 * priority: the link is for organising and finding them (`listNotesAbout`,
 * the person and priority pages' Notes sections, `notes_search`'s
 * `aboutPersonId` / `aboutPriorityId`). It is NEVER access: linking a note
 * to Mark does not let Mark read it — `visibleNoteWhere` decides that, and
 * only a `NoteShare` widens it.
 * 
 * TYPED FKs, one nullable column per target kind (ADR-0075's typed-FK arc),
 * not a polymorphic `(targetType, targetId)` pair: each target cascades with
 * its row and the database knows what it points at. The CHECK
 * `note_subjects_one_target_check` holds EXACTLY ONE target column non-null;
 * a new target kind is one nullable column plus that CHECK.
 * 
 * One link per note per target: the partial uniques below, one per target
 * column, so the add is idempotent (`createMany({ skipDuplicates })`).
 * `noteSubjectPerson` and `noteSubjectPriority` are partial-unique
 * `WhereUniqueInput` keys — never use them in
 * findUnique/upsert/connect/delete/update without a documented
 * `partial-unique-key-misuse-disable` annotation
 * (docs/conventions/PRISMA_MIGRATIONS.md § Partial indexes).
 * 
 * `orgId` has NO `@default` (#11901, ADR-0023).
 */
export type NoteSubject = Prisma.NoteSubjectModel
/**
 * Model NoteRollupInput
 * NoteRollupInput — one input note of one roll-up note (#14774, the roll-up notes spec (#14772)).
 * 
 * A note links the notes it adds up to here — its linked notes (#15963); a
 * note nothing captured whose content is these is a roll-up (#16019,
 * `src/lib/notes/rollups/rollup-shape.ts`). An input may itself link notes,
 * so the rows form a tree; the one writer (`linkNotes`,
 * `src/lib/notes/linked-notes.ts`) refuses a cycle at any depth
 * and caps the depth and the direct-input count. The CHECK constraint
 * `note_rollup_inputs_not_self` refuses the one cycle a single row can
 * carry — a note as its own input — in Postgres too.
 */
export type NoteRollupInput = Prisma.NoteRollupInputModel
/**
 * Model NoteChatSource
 * NoteChatSource — an AI Chat conversation, as its CHAT pulse, that wrote
 * into a note (#16109). Chat proposes `note.create` / `note.add_to`, the
 * person confirms, and the conversation is on the note as its SOURCE the
 * way a recording is a meeting note's.
 * 
 * A join table and never `Note.pulseId`: that column makes a note a PULSE
 * note (`noteShapeOf`), which `visibleNoteWhere` opens to the author's
 * management chain, and it is unique — one note per pulse. A chat-made note
 * stays private to its author, and one note can receive several chats.
 * 
 * `orgId` has NO `@default` (#11901, ADR-0023).
 */
export type NoteChatSource = Prisma.NoteChatSourceModel
/**
 * Model TranscriptSegment
 * TranscriptSegment — one timed span of transcript text. N3 writes these
 * incrementally, so a partially-failed transcription leaves the spans it
 * did produce rather than nothing.
 */
export type TranscriptSegment = Prisma.TranscriptSegmentModel
/**
 * Model TranscriptVersion
 * The readable and enhanced renderings of one recording's transcript
 * (#14298).
 * 
 * `readable` is the FAITHFUL one: the transcript's own words in paragraphs,
 * punctuated and cased, filler removed, checked token-by-token against the
 * segments it cites (`checkReadableFaithful`). It is what extraction and the
 * summary read. `enhanced` marks every inserted or changed phrase as an
 * inference with a confidence and a rationale; it is VIEW-ONLY until a
 * person corrects a paragraph, which makes that paragraph human-verified.
 * 
 * `kind` is a TEXT column whose closed list is `TRANSCRIPT_VERSION_KINDS` in
 * `src/lib/processing/transcript-versions.ts` (ADR-0107). `content` and
 * `coherence` are validated by the schemas in that same file on every read.
 */
export type TranscriptVersion = Prisma.TranscriptVersionModel
/**
 * Model TranscriptVersionWindow
 * One window of a live capture's transcript, with its coherence and
 * readable results computed WHILE the meeting was recorded (#14478), so the
 * post-Stop transcript-versions pass only runs what is left.
 * 
 * Written by `src/lib/notetaker/transcript-version-windows.ts` after a live
 * chunk commits; read by `runTranscriptVersionsStage`. A row is used only
 * while `fingerprint` still matches the window's segments — a late chunk or
 * a span correction makes it stale, and the pass then recomputes it. The
 * row is also the fill's claim: it is inserted (ON CONFLICT DO NOTHING)
 * before the model calls, so each window is computed once.
 */
export type TranscriptVersionWindow = Prisma.TranscriptVersionWindowModel
/**
 * Model ExtractedItem
 * ExtractedItem — a LITERAL quote from the transcript that looks like a
 * commitment or a decision, proposed for a human to accept or dismiss.
 * 
 * THERE IS NO `rationale` AND NO `suggestedNextStep` COLUMN, and the
 * omission is the product posture rather than an oversight: any generated
 * recommendation stored beside a meeting record risks construal as a
 * district obligation under public-records law. Literal transcript and
 * quoted action steps only — leaving the column out is what makes that
 * posture cheap to hold.
 */
export type ExtractedItem = Prisma.ExtractedItemModel
/**
 * Model TranscriptionJob
 * TranscriptionJob — the durable row that makes transcription resumable.
 * 
 * Shaped after `ContextResearchRun`, the repo's existing durable-job-row
 * pattern: a status vocabulary, an org-scoped row, and a runner that
 * advances it. What this one adds is `lastCommittedSegmentIndex`, and that
 * column is the whole point of the issue — transcription is slow, external
 * and fails in the middle, so a design that holds the transcript in memory
 * and writes once at the end turns twenty-eight successful minutes plus one
 * 429 into the total loss of a meeting nobody can repeat.
 */
export type TranscriptionJob = Prisma.TranscriptionJobModel
/**
 * Model OutputTemplate
 * OutputTemplate — a structured field list Cadence can fill from
 * conversations and data (Issue #14302): a state report, a board update, an
 * HR check-in form, created blank or from a screenshot / PDF of the form.
 * 
 * Holds the CURRENT name and fields; every version is snapshotted on
 * `OutputTemplateVersion`, and a response is filled against a
 * `(templateId, version)` pair. An edit to a version nothing has used
 * rewrites it in place; an edit after use mints `version + 1`
 * (`src/lib/output-templates/versioning.ts`).
 * 
 * `scope` and `sourceKind` are plain `String`s closed in code
 * (`OUTPUT_TEMPLATE_SCOPES`, `OUTPUT_TEMPLATE_SOURCE_KINDS` in
 * `src/lib/output-templates/fields.ts`, ADR-0107). `fields` is validated by
 * `outputTemplateFieldsSchema` on every write.
 */
export type OutputTemplate = Prisma.OutputTemplateModel
/**
 * Model OutputTemplateVersion
 * OutputTemplateVersion — the snapshot of one version of an
 * `OutputTemplate` (Issue #14302). What a filled response reads its field
 * list from, so a later edit never changes a response already filled.
 * 
 * `firstUsedAt` is null until the first response is filled against this
 * version; while it is null an edit rewrites the snapshot in place, and once
 * it is set the snapshot is never written again.
 */
export type OutputTemplateVersion = Prisma.OutputTemplateVersionModel
/**
 * Model TemplateResponse
 * TemplateResponse — one filling-in of an output template (Issue
 * #14303): the values a pulse or check-in conversation collected for a
 * template attached to it, the rest filled at completion by the
 * `templateFill` stage, or a response entered by hand.
 * 
 * Filled against a `(templateId, templateVersion)` pair — the version's
 * snapshot (`OutputTemplateVersion`) is the field list the response reads,
 * so a later edit of the template never changes a response already filled.
 * 
 * `values` is `{ [fieldKey]: { value, confidence, origin, sourceQuote } }`,
 * written only through `mergeTemplateValues` and read back entry by entry
 * through `storedTemplateValueSchema` (`src/lib/output-templates/responses.ts`).
 * A required field
 * with no value is left EMPTY and flagged — never invented.
 * 
 * `sourceKind` (`pulse_conversation` | `check_in` | `manual` | `note`) and `status`
 * (`draft` | `confirmed`) are plain `String`s closed in code (ADR-0107).
 * One response per template per source conversation (`@@unique` below;
 * a `manual` response has no `sourceId`, and NULLs never collide).
 */
export type TemplateResponse = Prisma.TemplateResponseModel
/**
 * Model OutputTemplateAttachment
 * OutputTemplateAttachment — which template a pulse or check-in
 * conversation collected (Issue #14303): the retired "Collect with" link.
 * `groupId` null is the org-wide default; a group row wins for the people
 * in that group (and its sub-groups), most specific first.
 * 
 * READ-ONLY since #16004, awaiting a contract migration that drops the
 * table. Nothing writes it. Pulse rows are copied onto the org weekly
 * practice (its org questions and unit layers) per org by
 * `scripts/backfill/move-template-attachments-to-practices.ts`; a weekly
 * reflection collects from the practice once the org has one and still
 * reads its pulse row until then. Check-in rows are still read by a review
 * period's check-in. Both reads: `src/lib/output-templates/attachment-read.ts`
 * — the check-in one until the check-in practice exists (#16013). The
 * drop follows both: every org's pulse rows moved, and E1 shipped.
 * 
 * `conversationKind` (`pulse` | `check_in`) is a plain `String` closed in
 * code (ADR-0107). One attachment per `(orgId, conversationKind, groupId)`,
 * enforced by the service (the org-wide row has a NULL `groupId`, which a
 * plain unique index would not collide).
 */
export type OutputTemplateAttachment = Prisma.OutputTemplateAttachmentModel
/**
 * Model OrgAiProfile
 * OrgAiProfile — the living org profile (#14292, part of #14286).
 * 
 * A concise, admin-editable markdown document describing how THIS org
 * actually operates. The learning job
 * (`src/lib/org-context/living-profile/update.ts`) rewrites it from new
 * signal at most once per org per day; admins edit it on
 * /admin/company-info/ai-profile. Every change — AI, human or revert — is
 * recorded as an `OrgAiProfileRevision`, so this row is only ever the
 * current state.
 * 
 * One per org: `orgId` is unique. `updatedByKind` is a code-level
 * vocabulary ('ai' | 'human', `ORG_AI_PROFILE_UPDATED_BY_KINDS`), never a
 * Postgres enum (ADR-0107). `content` is capped at 800 words / 5,000 chars by
 * `checkProfileContent`, not by the column.
 */
export type OrgAiProfile = Prisma.OrgAiProfileModel
/**
 * Model OrgAiProfileRevision
 * OrgAiProfileRevision — one append-only entry in a living profile's history
 * (#14292). Written for every AI edit, human save and revert; never updated
 * or deleted by the app. A revert restores a revision's `previousContent` as
 * a NEW `source = 'revert'` row, so history only grows.
 * 
 * `source` is a code-level vocabulary ('ai' | 'human' | 'revert',
 * `ORG_AI_PROFILE_REVISION_SOURCES`), never a Postgres enum (ADR-0107).
 * `evidenceRefs` is a JSON array of `{ kind, id }` pointing at the Evidence,
 * Belief, MeetingSummary and AiBeliefCorrection rows an AI edit learned from
 * — loose references, because the rows it cites may later be deleted and
 * the audit entry must survive them.
 */
export type OrgAiProfileRevision = Prisma.OrgAiProfileRevisionModel
